<template>
	<div class="add-ret-container">
		<!-- 全局加载状态 -->
		<div v-if="isLoading" class="global-loading-overlay">
			<div class="loading-content">
				<i class="el-icon-loading"></i>
				<span style="color:#00aa7f">{{ loadingText || '数据加载中...' }}</span>
			</div>
		</div>

		<!-- 主内容区域 - 整合第一个文件的模态框内容 -->
		<div class="main-content-wrapper">
			<div class="purchase-detail-content">
				<!-- 新增 -->
				<div class="addAcc" ref='myBox'>
					<!-- tabs -->
					<div class="tabs">
						<div class="tabsMain">
							<!-- 表单 header -->
							<div class="header-section">
								<h5 class="section-title">基本信息</h5>
								<div class="headerForm">
									<el-form ref="addForm" :rules="addFormRules" :model="addForm" label-width="100px"
										size="mini" :label-position="labelPosition">
										<el-row :gutter="16">
											<el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl"
												type="flex" v-for="(val,i) in formType" :key="i">
												<!-- input -->
												<el-form-item v-if="val.type == 'input'" :label="val.label"
													:prop="val.modelValue">
													<el-input :suffix-icon='val.prefix'
														v-model="$data.addForm[val.modelValue]"
														:placeholder="val.placeholder"
														:disabled="val.disabled"></el-input>
												</el-form-item>
												<!-- textarea -->
												<el-form-item v-if="val.type == 'textarea'" :label="val.label"
													:prop="val.modelValue">
													<el-input type="textarea" :rows="2" placeholder="请输入内容"
														v-model="$data.addForm[val.modelValue]"></el-input>
												</el-form-item>
												<!-- select -->
												<el-form-item v-if="val.type == 'select'" :label="val.label"
													:prop="val.modelValue">
													<el-select v-model="$data.addForm[val.modelValue]" filterable
														placeholder="请选择" @focus="sname(val,i)" @change="handleChange"
														:disabled="val.disabled">
														<el-option v-for="item in $data[val.op]" :key="item.id"
															:label="item.label" :value="item.id">
															<span
																style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
													</el-select>
												</el-form-item>
												<!-- date -->
												<el-form-item v-if="val.type == 'date'" :label="val.label"
													:prop="val.modelValue">
													<el-date-picker :picker-options="pickerOptions"
														:disabled="val.disabled ? true : false"
														value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
														v-model="$data.addForm[val.modelValue]">
													</el-date-picker>
												</el-form-item>
												<!-- btn -->
												<el-form-item v-if="val.type == 'btn'">
													<el-button type="primary" plain
														@click="clickEvents(val,i)">{{ val.label }}</el-button>
												</el-form-item>
											</el-col>
										</el-row>
									</el-form>
								</div>
							</div>

							<!-- 表单数据！第二层取addForm下的list -->
							<div class="main-section">
								<h5 class="section-title">卫材明细</h5>
								<div class="mainForm">
									<el-form ref="addMainForm" :rules="addMainFormRules" :model="addMainForm"
										label-width="90px" size="mini">
										<el-row :gutter="16">
											<el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl"
												type="flex" v-for="(val,i) in formMainType" :key="i">
												<!-- 卫材名称选择器 - 简化Tooltip版 -->
												<el-form-item v-if="val.type == 'selectFirst'" :label="val.label" :prop="val.modelValue">
												  <el-select
												    v-model="$data.addMainForm[val.modelValue]"
												    clearable
												    :disabled="val.disabled ? disabled : val.disabled"
												    filterable
												    @focus="handlefoucs(val,i)"
												    @change="handleChangeDrug"
												    @clear="clearSelect"
												    :filter-method="searchMethod"
												    :popper-append-to-body="false"
												    class="drug-name-select"
												  >
												    <el-group>
												      <!-- 固定头部 -->
												      <div class="select-header" slot="header" style="
												        font-size: 12px;
												        font-weight: bold;
												        display: grid;
												        grid-template-columns: 60px 188px 150px 100px 120px 150px;
												        gap: 8px;
												        text-align: left;
												        position: sticky;
												        top: 0;
												        z-index: 10;
												        background-color: #f8f9fa;
												        border-bottom: 1px solid #e0e0e0;
												        min-width: 500px;
												      ">
												        <span style="text-align: center;">库存序号</span>
												        <span>卫材名称</span>
												        <span>卫材规格</span>
												        <span style="text-align: right;">库存数量</span>
												        <span style="text-align: center;">批次号</span>
												        <span>生产厂家</span>
												      </div>
												
												      <!-- 选项内容 -->
												      <el-option
												        v-for="item in filteredNameOption"
												        :key="item.id"
												        :label="item.label"
												        :value="item.id"
												        :disabled="item.disabled"
												        class="drug-option-item"
												      >
												        <div class="option-item-content" style="
												          display: grid;
												          grid-template-columns: 60px 188px 150px 100px 120px 150px;
												          gap: 8px;
												          align-items: center;
												          width: 100%;
												          min-width: 500px;
												        ">
												          <!-- 库存序号 -->
												          <span class="field-cell index-cell" style="
												            text-align: center;
												            font-weight: 500;
												            color: #666;
												            white-space: nowrap;
												            overflow: hidden;
												            text-overflow: ellipsis;
												          ">{{ item.id }}</span>
												
												          <!-- 卫材名称 - 简化Tooltip -->
												          <el-tooltip
												            :content="item.eisaiName"
												            placement="top"
												            :disabled="!item.eisaiName"
												            effect="light"
												            :open-delay="300"
												          >
												            <span class="field-cell name-cell" style="
												              white-space: nowrap;
												              overflow: hidden;
												              text-overflow: ellipsis;
												              color: #333;
												              font-weight: 500;
												              border-right: 1px solid #f0f0f0;
												              padding-right: 8px;
												              width: 188px;
												              max-width: 188px;
												              min-width: 188px;
												              display: inline-block;
												            ">{{ item.eisaiName || '-' }}</span>
												          </el-tooltip>
												
												          <!-- 卫材规格 - 简化Tooltip -->
												          <el-tooltip
												            :content="item.specDesc"
												            placement="top"
												            :disabled="!item.specDesc"
												            effect="light"
												            :open-delay="300"
												          >
												            <span class="field-cell spec-cell" style="
												              white-space: nowrap;
												              overflow: hidden;
												              text-overflow: ellipsis;
												              color: #666;
												              border-right: 1px solid #f0f0f0;
												              padding-right: 8px;
												              width: 150px;
												              max-width: 150px;
												              min-width: 150px;
												              display: inline-block;
												            ">{{ item.specDesc || '-' }}</span>
												          </el-tooltip>
												
												          <!-- 库存数量 -->
												          <span class="field-cell stock-cell" style="
												            text-align: right;
												            font-weight: 600;
												            color: #e6a23c;
												            white-space: nowrap;
												            overflow: hidden;
												            text-overflow: ellipsis;
												            border-right: 1px solid #f0f0f0;
												            padding-right: 8px;
												            width: 100px;
												            max-width: 100px;
												            min-width: 100px;
												            display: inline-block;
												          ">{{ item.purcCnt || 0 }}</span>
												
												          <!-- 批次号 - 简化Tooltip -->
												          <el-tooltip
												            :content="item.manuLotnum"
												            placement="top"
												            :disabled="!item.manuLotnum"
												            effect="light"
												            :open-delay="300"
												          >
												            <span class="field-cell batch-cell" style="
												              text-align: center;
												              white-space: nowrap;
												              overflow: hidden;
												              text-overflow: ellipsis;
												              color: #909399;
												              font-size: 11px;
												              border-right: 1px solid #f0f0f0;
												              padding-right: 8px;
												              width: 120px;
												              max-width: 120px;
												              min-width: 120px;
												              display: inline-block;
												            ">{{ item.manuLotnum || '-' }}</span>
												          </el-tooltip>
												
												          <!-- 生产厂家 - 简化Tooltip -->
												          <el-tooltip
												            :content="item.prodentpName"
												            placement="top"
												            :disabled="!item.prodentpName"
												            effect="light"
												            :open-delay="300"
												          >
												            <span class="field-cell manufacturer-cell" style="
												              white-space: nowrap;
												              overflow: hidden;
												              text-overflow: ellipsis;
												              color: #67c23a;
												              font-size: 12px;
												              width: 150px;
												              max-width: 150px;
												              min-width: 150px;
												              display: inline-block;
												            ">{{ item.prodentpName || '-' }}</span>
												          </el-tooltip>
												        </div>
												      </el-option>
												
												      <!-- 没有选项时 -->
												      <div v-if="filteredNameOption.length === 0" class="no-options" style="
												        padding: 20px;
												        text-align: center;
												        color: #999;
												        font-size: 13px;
												        min-width: 500px;
												      ">
												        暂无卫材数据
												      </div>
												    </el-group>
												  </el-select>
												</el-form-item>
												<!-- select -->
												<el-form-item v-if="val.type == 'select'" :label="val.label"
													:prop="val.modelValue">
													<el-select v-model="$data.addMainForm[val.modelValue]"
														:disabled="val.disabled ? disabled : val.disabled" filterable>
														<el-option v-for="item in $data[val.op]" :key="item.id"
															:label="item.label" :value="item.id">
															<span
																style="font-size: 12px">{{ item.label }}</span></el-option>
														</el-option>
													</el-select>
												</el-form-item>
												<!-- input 数量 -->
												<el-form-item v-if="val.type == 'inputNum'" :label="val.label"
													:prop="val.modelValue">
													<el-input placeholder="" v-model="$data.addMainForm[val.modelValue]"
														class="input-with-select" @input="gotoPrice">
														<el-select v-model="purcType" slot="prepend"
															@change="SelectedPurcType" placeholder="库存类型"
															style="width: 98px;">
															<el-option label="最小单位" value="1"></el-option>
															<el-option label="包装单位" value="2"></el-option>
														</el-select>
														<span slot="append"
															icon="el-icon-search">{{ purcType == 1 ? minUnt : unt }}</span>
													</el-input>
													<!-- <el-input :suffix-icon='val.prefix' v-model="$data.addMainForm[val.modelValue]" @blur="handleInput(val,i)" :disabled="val.disabled" ></el-input> -->
												</el-form-item>
												<!-- input -->
												<el-form-item v-if="val.type == 'input'" :label="val.label"
													:prop="val.modelValue">
													<el-input :suffix-icon='val.prefix'
														v-model="$data.addMainForm[val.modelValue]"
														@input="handleInput(val,i)" :disabled="val.disabled"></el-input>
												</el-form-item>
												<!-- textarea -->
												<el-form-item v-if="val.type == 'textarea'" :label="val.label"
													:prop="val.modelValue">
													<el-input type="textarea" :rows="2" placeholder="请输入内容"
														v-model="$data.addMainForm[val.modelValue]"
														:disabled="val.disabled"></el-input>
												</el-form-item>
												<!-- date -->
												<el-form-item v-if="val.type == 'date'" :label="val.label"
													:prop="val.modelValue">
													<el-date-picker class="autoWidth"
														:picker-options="expyDatePickerOptions" :disabled="val.disabled"
														type="date" placeholder="选择日期"
														v-model="$data.addMainForm[val.modelValue]">
													</el-date-picker>
												</el-form-item>
												<!-- btn -->
												<el-form-item v-if="val.type == 'btn'">
													<el-button type="primary" plain
														@click="clickEvents(val,i)">{{ val.label }}</el-button>
												</el-form-item>
											</el-col>
										</el-row>
									</el-form>
								</div>
							</div>

							<!-- table -->
							<div class="table-section">
								<div class="section-header">
									<h4 class="section-title">已选卫材列表</h4>
									<div class="total-info">
										<span class="total-item">成本合计：¥{{ cbValue || '0.00' }}</span>
										<span class="total-item">零售合计：¥{{ lsValue || '0.00' }}</span>
										<span class="total-item">共 {{ tableData?.length || 0 }} 种卫材</span>
									</div>
								</div>
								<div class="table">
									<el-table :data="tableData" border :style="{ width: '100%' }"
										:cell-class-name="tableCellClassName" @row-dblclick="dbclick"
										v-loading="loading" stripe>
										<el-table-column prop="purcType" label="库存类型" width="100">
											<template slot-scope="{ row }">
												<span
													:style="{ color: purcTypeColorMap[row.purcType] }">{{ purcTypeMap[row.purcType] || '未知' }}</span>
											</template>
										</el-table-column>
										<!-- 字段映射 -->
										<el-table-column prop="eisaiName" label="卫材名称" align='center' width="140"
											show-overflow-tooltip></el-table-column>
										<el-table-column prop="specDesc" label="规格描述" align='center' width="150"
											show-overflow-tooltip></el-table-column>
										<!-- 在el-table-column中添加可编辑列 -->
										<el-table-column prop="apllyAmt" label="出库数量" width="120">
											<template slot-scope="scope">
												<el-input 
												  v-if="scope.row.editing" 
												  v-model.number="scope.row.apllyAmt"
												  size="mini" 
												  :max="scope.row.purcCnt"
												  @blur="validateAmountOnBlur(scope.row)"
												  @change="handleAmountChange(scope.row)"
												  :title="`最大可出库数量：${scope.row.purcCnt}`"
												  :data-row-id="scope.row.id"
												  class="editing-input"
												></el-input>
												<span v-else>{{ scope.row.apllyAmt + scope.row.unt }}</span>
											</template>
										</el-table-column>
										<el-table-column prop="manuLotnum" label="生产批号" width="120"></el-table-column>
										<el-table-column prop="expyDate" label="有效日期" width="120"></el-table-column>
										<el-table-column prop="prodentpName" label="生产厂家" align='center' width="150"
											show-overflow-tooltip></el-table-column>
										<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
											:prop="col.prop" :label="col.name"
											:width="columnWidth(col, tableData)"></el-table-column>
										<!-- fixed -->
										<el-table-column fixed="left" label="行号" width="68" align="center">
											<template slot-scope="scope">
												{{ scope.$index + 1 }}
											</template>
										</el-table-column>
										<!-- edit -->
										<!-- 在表格操作区域添加重新验证按钮 -->
										<el-table-column fixed="right" label="操作" width="200">
											<template slot-scope="scope">
												<div class="edit-actions">
													<template v-if="!scope.row.editing">
														<el-button 
														  v-if="!scope.row.editing" 
														  type="primary" 
														  size="mini"
														  @click="enableEditing(scope.row)"
														  :title="`库存: ${scope.row.purcCnt}, 模式: ${mode === 'edit' ? '编辑模式' : '新增模式'}`"
														  :disabled="isEditing"
														>
														  编辑
														</el-button>

														<el-button v-if="scope.row.hasJoinWarning || scope.row.isError"
															type="warning" size="mini"
															@click="revalidateStock(scope.row)"
															:loading="scope.row.validating">
															{{ scope.row.validating ? '验证中' : '重新验证' }}
														</el-button>

														<el-button type="danger" size="mini"
															@click="deleteRow(scope.$index)"
															:disabled="isEditing">删除</el-button>
													</template>

													<template v-else>
														<!-- 在保存按钮中添加title提示 -->
														<el-button 
														  v-if="scope.row.editing"
														  type="success" 
														  size="mini"
														  @click="saveEdit(scope.row)"
														  :title="`当前数量: ${scope.row.apllyAmt}, 最大允许: ${mode === 'edit' ? scope.row.purcCnt : (scope.row.availableQuantity || scope.row.purcCnt)}`"
														>
														  保存
														</el-button>

														<el-button type="info" size="mini"
															@click="cancelEdit(scope.row)">取消</el-button>
													</template>
												</div>
											</template>
										</el-table-column>

										<!-- 在表格顶部添加批量操作按钮 -->
										<div class="table-actions"
											style="margin-bottom: 10px; display: flex; justify-content: space-between;">
											<div>
												<el-button type="warning" size="mini" @click="revalidateAllStock"
													:loading="loadingText !== ''" v-if="tableData.length > 0">
													<i class="el-icon-refresh"></i>
													重新验证所有库存
												</el-button>

												<span v-if="hasStockWarnings"
													style="color: #e6a23c; margin-left: 10px;">
													<i class="el-icon-warning"></i>
													部分卫材库存验证失败，请检查
												</span>
											</div>

											<div>
												<span class="total-item">成本合计：¥{{ cbValue || '0.00' }}</span>
												<span class="total-item"
													style="margin-left: 15px;">零售合计：¥{{ lsValue || '0.00' }}</span>
												<span class="total-item" style="margin-left: 15px;">共
													{{ tableData.length }} 种卫材</span>
											</div>
										</div>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部操作按钮 -->
		<div class="action-buttons">
		  <el-button size="medium" @click="handleReturn">放弃</el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="info" 
		    plain 
		    @click="draftSubmit"
		    v-if="mode === 'add'"
		  >
		    存为草稿
		  </el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="primary" 
		    plain 
		    @click="addSubmit"
		    v-if="mode === 'add'"
		  >
		    保存提交
		  </el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="primary" 
		    plain 
		    @click="editSubmit"
		    v-if="mode === 'edit'"
		  >
		    修改提交
		  </el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="info" 
		    plain 
		    @click="draftSubmit"
		    v-if="mode === 'edit'"
		  >
		    存为草稿
		  </el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="success" 
		    plain 
		    @click="handleAudit"
		    v-if="currentRow && currentRow.state === 2"
		  >
		    审核
		  </el-button>
		  <el-button 
		    size="medium" 
		    :disabled="isEditing" 
		    type="warning" 
		    plain 
		    @click="handlePass"
		    v-if="currentRow && currentRow.state === 4"
		  >
		    过单
		  </el-button>
		</div>
	</div>
</template>

<script>
	// 导入第一个文件的相关模块
	import AccType from './addReturnType.js'
	import AccMainType from './AddReturnMainType.js'
	import addForm from './addForm.js'
	import {
		getLunar
	} from 'chinese-lunar-calendar'
	import {
		addWCOutbound,
		editWCdocOut,
		selectDropDownList,
		selectWCDrug,
		getTretn,
		docOutWCJoin,
		docOutgetRetnList,
		toRetnWCExamine
	} from "@/api/PSI/shopReturn.js";

	import {
		getDrugDetails
	} from "@/api/PSI.js";
	export default {
		name: 'AddRet',
		props: {
			currentRow: {
				type: Object,
				default: null
			},
			mode: {
				type: String,
				default: 'add'
			},
			selectedIds: { // 新增：接收选中的ID数组
			    type: Array,
			    default: () => []
			  }
		},
		data() {
			// 表单校验取大于0的数字型数据
			var validatePercentage = (rule, value, callback) => {
				if (value == '') {
					return callback(new Error('出库数量不能为空！'));
				} else if (value > this.addMainForm.purcCnt) {
					return callback(new Error('出库数量不能大于已有的库存数量！'));
				}
				callback();
			};

			return {
				// 第二个页面的数据
				activeDocType: 'return',

				// 第一个文件的数据
				//str
				dialogTitle: '新建采购出库【西药】',
				packNum: 0,
				getMinMax: 0,
				purcType: '1', // 库存类型 = > 判断大小单位 1最小单位,2包装单位
				unt: '', // 包装单位 （数量：盒？包？g?）
				minUnt: '', // 最小单位 （数量：盒？包？g?）
				tableWidth: '', //右侧表格动态宽度
				labelPosition: 'right',
				dosUnt: '?', // 动态包装单位
				value: '',
				inputSearchValue: '',
				deptCode: '',
				getLunarDay: '',
				eisaiName: '',
				appId: '', // * 选择采购计划时的Id
				startDate: '', // * 开始时间
				endDate: '', // * 结束时间
				idx: '',
				cbValue: '',
				lsValue: '',
				currentCell: null, // 单元格隐藏
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				date: new Date().getDate(),
				lunarDate: '', //农历
				// 1 - 3
				firstName: '',
				seconedName: '',
				thirdName: '',
				auditStatus: '5',
				//num
				pageNum: 1, //当前页currentPage
				pageSize: 6,
				KcNum: 0, // 库存数量
				totalSize: 10, //总条数
				//ble
				loading: false,
				disabled: true,
				totaldisabled: true,
				addghdwDialog: false,
				selectDisabled: true,
				isEditShow: false,
				innerVisible: false, //内层Model选择采购计划
				oldData: {}, // 用于保存编辑前的数据
				formMainType: [], // 确保初始化为数组
				feetBtn: [], // 确保初始化为数组
				tableData: [], // 确保初始化为数组
				// 添加编辑状态控制变量
				editingRow: null,
				// 添加编辑状态控制变量
				isEditing: false, // 控制是否处于编辑状态
				editDisabledMap: {}, // 用于记录每行的编辑按钮禁用状态
				//arr
				formType: [], // 表单头部内容

				tableRows: [
				  {
				    name: "库存数量",
				    prop: "purcCnt", // 库存数量
				    type: ""
				  }, 
				  {
				    name: "出库数量", // 修改标签
				    prop: "apllyAmt", // 修改为apllyAmt
				    type: ""
				  },
				  {
				    name: "库存单位",
				    prop: "unt",
				    type: ""
				  },
				  {
				    name: "成本单价",
				    prop: "retnPric",
				    type: ""
				  }, 
				  {
				    name: "成本金额",
				    prop: "retnAmt",
				    type: ""
				  },
				  {
				    name: "零售单价",
				    prop: "salePric",
				    type: ""
				  }, 
				  {
				    name: "零售金额",
				    prop: "saleAmt",
				    type: ""
				  },
				],
				innertableData: [], //内层采购计划数据源
				currentObj: {}, //内层采购计划数据源 = > 单击选择
				currentTable: [], //表格单选
				selectOption: [{
					id: 9,
					label: '耗材库'
				}], //库房
				stateOptions: [{
					id: 0,
					label: '草稿'
				}, {
					id: 2,
					label: '提交'
				}],
				kcOptions: [{
					id: 1,
					label: '最小单位',
					value: '最小单位'
				}, {
					id: 2,
					label: '包装单位',
					value: '包装单位'
				}], // 库存类型
				ghdwOption: [{
					id: 1,
					label: '水富市人民医院',
					value: '水富市人民医院'
				}, {
					id: 2,
					label: '昆明灵泽科技有限公司',
					value: '昆明灵泽科技有限公司'
				}, ],
				purcTypeMap: {
					1: '最小单位',
					2: '包装单位',
				},
				purcTypeColorMap: {
					1: '#67C23A',
					2: '#409EFF',
				},
				retnTypeOptions: [{
						id: 11,
						label: '采购退库',
						value: '采购退库'
					}, {
						id: 12,
						label: '报损出库',
						value: '报损出库'
					}, {
						id: 13,
						label: '过期出库',
						value: '过期出库'
					},
					{
						id: 14,
						label: '捐赠出库',
						value: '捐赠出库'
					}, {
						id: 15,
						label: '其他出库',
						value: '其他出库'
					}, {
						id: 16,
						label: '输错出库',
						value: '输错出库'
					},
					{
						id: 17,
						label: '科室出库',
						value: '科室出库'
					}, {
						id: 18,
						label: '销售出库',
						value: '销售出库'
					}, {
						id: 19,
						label: '拆零自动出库',
						value: '拆零自动出库'
					},
				],
				// 表单验证规则 header
				addFormRules: {
					shedId: [{
						required: true,
						message: '请先选择要入库的库房！',
						trigger: 'change'
					}],
					supplyCandidateId: [{
						required: true,
						message: '请选择供货单位！',
						trigger: 'change'
					}],
					retnTypeId: [{
						required: true,
						message: '请选择出库方式！',
						trigger: 'change'
					}],
				},
				// 表单验证规则 main
				addMainFormRules: {
					eisaiId: [{
						required: true,
						message: '请先选择卫材信息！',
						trigger: 'change'
					}],
					manuLotnum: [{
						required: true,
						message: '请输入卫材的生产批号！',
						trigger: 'blur'
					}],
					// 修改：将retnCnt改为apllyAmt
					  apllyAmt: [{
					      required: true,
					      message: '出库的数量为必填项！',
					      trigger: 'blur'
					    },
					    {
					      validator: (rule, value, callback) => {
					        // 验证是否为非0正整数
					        if (!/^[1-9][0-9]*$/.test(value)) {
					          callback(new Error('出库的数量为非0正整数!'));
					        } else {
					          callback();
					        }
					      },
					      trigger: 'blur'
					    }
					  ],
					expyDate: [{
						required: true,
						message: '卫材的有效日期不能为空！',
						trigger: 'change'
					}],
					purcType: [{
						required: true,
						message: '请先选择库存类型！',
						trigger: 'change'
					}],
				},
				
				isLoading: false,
				// 单据状态 0 草稿,1 回退提交,2 已提交,3 回退审核,4 已审核,5 已过单,6 已作废'
				statusOption: [{
					id: 0,
					label: '草稿'
				}, {
					id: 1,
					label: '回退提交'
				}, {
					id: 2,
					label: '已提交'
				}, {
					id: 3,
					label: '回退审核'
				}, {
					id: 4,
					label: '已审核'
				}, {
					id: 5,
					label: '已过单'
				}, {
					id: 6,
					label: '已作废'
				}, ],

				sexOptions: [{
					id: 1,
					label: '男',
					value: '男'
				}, {
					id: 2,
					label: '女',
					value: '女'
				}],
				marryiedOptions: [{
					id: 1,
					label: '未婚',
					value: '未婚'
				}, {
					id: 2,
					label: '已婚',
					value: '已婚'
				}, {
					id: 3,
					label: '离异',
					value: '离异'
				}, {
					id: 4,
					label: '丧偶',
					value: '丧偶'
				}, {
					id: 5,
					label: '再婚',
					value: '再婚'
				}],
				nameOption: [],
				ckWaysOptions: [],
				//obj
				addForm: {}, // form表单 * 
				addMainForm: {}, // form主体表单 * addForm.list
				lists: {},
				options: [],
				ssrOption: [],
				gysOption: [],
				ManufacturerOptions: [],
				loadingText: '',  // 新增：加载文本提示
				//props
				pickerOptions: {},
				expyDatePickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
					shortcuts: [{
							text: '三个月后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '明年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						},
						{
							text: '后年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 720);
								picker.$emit('pick', date);
							}
						},
						{
							text: '三年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 3);
								picker.$emit('pick', date);
							}
						},
						{
							text: '五年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 5);
								picker.$emit('pick', date);
							}
						},
						{
							text: '十年后',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 360 * 10);
								picker.$emit('pick', date);
							}
						},
					]
				},
				// 在data中添加watch属性 , 使表格能随着 addMainForm 的变化而更新数据。主要需要修改 enableEditing 方法和添加对 addMainForm 的监听。
				watch: {
					addMainForm: {
						handler(newVal) {
							if (newVal.editing) {
								// 找到表格中对应的行并更新
								const index = this.tableData.findIndex(item => item.eisaiId === newVal.eisaiId);
								if (index !== -1) {
									this.$set(this.tableData, index, newVal);
								}
							}
						},
						deep: true
					}
				}
			}
		},
		// 在data中添加一个计算属性来过滤nameOption
		computed: {
			// 检查是否有库存警告
			hasStockWarnings() {
				return this.tableData.some(row => row.hasJoinWarning || row.isError);
			},

			// 统计库存验证状态
			stockValidationStats() {
				const total = this.tableData.length;
				const success = this.tableData.filter(row => !row.hasJoinWarning && !row.isError).length;
				const warning = this.tableData.filter(row => row.hasJoinWarning).length;
				const error = this.tableData.filter(row => row.isError).length;

				return {
					total,
					success,
					warning,
					error
				};
			},
			// 模式文本显示
			modeText() {
				const textMap = {
					'add': '新增采购出库',
					'edit': '编辑采购出库',
					'view': '查看采购出库'
				};
				return textMap[this.mode] || '采购出库';
			},

			filteredNameOption() {
				// 获取表格中所有的eisaiId
				const existingDrugIds = this.tableData.map(item => item.eisaiId);
				// 过滤掉已经存在于表格中的卫材
				return this.nameOption.filter(item => !existingDrugIds.includes(item.id));
			},
			// 在表格列配置中添加库存验证状态列
			tableColumns() {
				const baseColumns = [
					// 原有列配置...
					{
						prop: 'purcCnt',
						label: '库存数量',
						width: 100,
						align: 'center'
					},
					{
						prop: 'availableQuantity',
						label: '可退库数量',
						width: 100,
						align: 'center',
						formatter: (row) => {
							if (row.isError) {
								return '<span style="color: #f56c6c;" title="处理失败">--</span>';
							}
							return row.availableQuantity || 0;
						}
					},
					{
						prop: 'stockStatus',
						label: '库存状态',
						width: 100,
						align: 'center',
						formatter: (row) => {
							if (row.isError) {
								return '<span style="color: #f56c6c;">处理失败</span>';
							}
							if (row.hasJoinWarning) {
								return '<span style="color: #e6a23c;">验证失败</span>';
							}
							const available = row.availableQuantity || 0;
							const requested = row.retnCnt || 0;
							if (available >= requested) {
								return '<span style="color: #67c23a;">库存充足</span>';
							} else {
								return '<span="color: #f56c6c;">库存不足</span>';
							}
						}
					}
				];

				return baseColumns;
			},
		},
		created() {

		},
		mounted() {
		  // 获取接口参数
		  this.getAddForm();
		  this.ckWays();
		  this.getGys();
		  // 获取当前日期时间
		  this.getNowDateTime();
		
		  // 如果是编辑或查看模式，加载数据
		  if (this.mode === 'edit' || this.mode === 'view') {
		    this.loadRowData();
		  }
		  
		  // 新增：检查是否有选中的ID需要自动加载
		  if (this.selectedIds && this.selectedIds.length > 0) {
		    this.$nextTick(() => {
		      setTimeout(() => {
		        this.fillWithSelectedIds(this.selectedIds);
		      }, 500);
		    });
		  }
		  
		  // 新增：如果是编辑模式，确保数据正确加载
		  if (this.mode === 'edit' && this.currentRow) {
		    this.$nextTick(() => {
		      this.ensureEditDataLoaded();
		    });
		  }
		},

		methods: {
			// 采购计划数据
			async loadData() {
				let res = await getPurchasingPlan({
					auditStatus: this.auditStatus,
					startDate: this.startDate,
					endDate: this.endDate,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				if (res.code == 200) {
					this.innertableData = res.data.content
					this.totalSize = res.data.totalSize
				} else {
					this.$message({
						type: 'error',
						message: res.message
					});
				}
			},
			// 新增：确保编辑数据加载
			async ensureEditDataLoaded() {
			  try {
			    console.log('开始加载编辑数据，当前行数据:', this.currentRow);
			    
			    // 检查是否有必要从接口重新获取数据
			    if (this.currentRow && this.currentRow.id) {
			      // 如果currentRow已经有list数据，直接使用
			      if (this.currentRow.list && Array.isArray(this.currentRow.list)) {
			        console.log('使用现有的list数据，数量:', this.currentRow.list.length);
			        this.loadEditDataFromCurrentRow();
			      } else {
			        // 如果没有list数据，从接口获取
			        console.log('当前行缺少list数据，从接口获取...');
			        await this.loadEditDataFromApi();
			      }
			    }
			  } catch (error) {
			    console.error('加载编辑数据失败:', error);
			    this.$message.error('加载编辑数据失败: ' + error.message);
			  }
			},
			
			// 修改：从currentRow加载编辑数据 - 确保apllyAmt有值
			loadEditDataFromCurrentRow() {
			  if (!this.currentRow) return;
			  
			  // 填充卫材明细
			  if (this.currentRow.list && Array.isArray(this.currentRow.list)) {
			    this.tableData = this.currentRow.list.map((item, index) => {
			      const invId = item.invId || item.invyId || item.id;
			      
			      // 关键修改：确保apllyAmt有值，优先使用retnCnt，如果为0则设为1
			      const apllyAmt = item.retnCnt > 0 ? item.retnCnt : 1;
			      
			      const tableRow = {
			        id: item.id || index + 1,
			        eisaiId: item.eisaiId,
			        eisaiName: item.eisaiName || '',
			        drugCode: item.drugCode || '',
			        specDesc: item.specDesc || item.drugSpecifications || '',
			        apllyAmt: apllyAmt, // 使用计算后的apllyAmt
			        retnCnt: item.retnCnt || apllyAmt,
			        retnPric: item.retnPric || 0,
			        salePric: item.salePric || 0,
			        retnAmt: item.retnAmt || 0,
			        saleAmt: item.saleAmt || 0,
			        manuLotnum: item.manuLotnum || '',
			        prodentpName: item.prodentpName || '',
			        unt: item.unt || '',
			        purcCnt: item.purcCnt || 0,
			        purcType: item.purcType || '2',
			        invId: invId,
			        invyId: item.invyId || invId,
			        // 编辑模式下，availableQuantity设置为库存数量
			        availableQuantity: item.purcCnt || 0,
			        editing: false
			      };
			      
			      return tableRow;
			    });
			    
			    // 重新计算合计金额
			    this.calculateTotals();
			  }
			},
			
			// 新增：从接口加载编辑数据
			async loadEditDataFromApi() {
			  if (!this.currentRow || !this.currentRow.id) {
			    this.$message.error('无效的编辑数据');
			    return;
			  }
			  
			  try {
			    this.isLoading = true;
			    this.loadingText = '正在加载编辑数据...';
			    
			    const res = await getRetnDetail({ id: this.currentRow.id });
			    
			    if (res.code === 200 && res.data) {
			      const data = res.data;
			      
			      // 更新currentRow
			      this.currentRow = {
			        ...this.currentRow,
			        ...data,
			        list: data.list || []
			      };
			      
			      // 重新加载数据
			      this.loadEditDataFromCurrentRow();
			    } else {
			      throw new Error(res.message || '获取详情失败');
			    }
			  } catch (error) {
			    console.error('从接口加载编辑数据失败:', error);
			    this.$message.error('加载编辑数据失败: ' + error.message);
			  } finally {
			    this.isLoading = false;
			    this.loadingText = '';
			  }
			},
			// 新增：加载编辑数据
			loadEditData() {
			  if (!this.currentRow) return;
			  
			  // 填充基本信息
			  this.addForm = {
			    id: this.currentRow.id,
			    docNum: this.currentRow.docNum,
			    busDate: this.currentRow.busDate,
			    shedId: this.currentRow.shedId,
			    retnTypeId: this.currentRow.retnTypeId,
			    supplyCandidateId: this.currentRow.supplyCandidateId,
			    supplierName: this.currentRow.supplierName,
			    remark: this.currentRow.remark,
			    state: this.currentRow.state
			  };
			  
			  // 如果有list数据，填充卫材明细
			  if (this.currentRow.list && Array.isArray(this.currentRow.list)) {
			    this.tableData = this.currentRow.list.map(item => {
			      return {
			        id: item.id,
			        eisaiId: item.eisaiId,
			        eisaiName: item.eisaiName,
			        drugCode: item.drugCode,
			        specDesc: item.specDesc || item.drugSpecifications,
			        apllyAmt: item.retnCnt, // 注意字段映射
			        retnCnt: item.retnCnt,
			        retnPric: item.retnPric,
			        salePric: item.salePric,
			        retnAmt: item.retnAmt,
			        saleAmt: item.saleAmt,
			        manuLotnum: item.manuLotnum,
			        prodentpName: item.prodentpName,
			        unt: item.unt,
			        purcCnt: item.purcCnt,
			        purcType: item.purcType || '2',
			        editing: false
			      };
			    });
			    
			    // 重新计算合计金额
			    this.calculateTotals();
			  }
			},
			/* 入库卫材数据源 */
			async getProData() {
				let res = await selectWCDrug({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					eisaiName: this.eisaiName
				});

				if (res.code === 200) {
					// 按照 eisaiName 进行排序
					const sortedData = res.data.content.sort((a, b) => {
						// 如果 eisaiName 相同，可以按照其他字段排序（如 eisaiId）
						if (a.eisaiName === b.eisaiName) {
							return a.eisaiId - b.eisaiId;
						}
						// 否则按照 eisaiName 升序排序
						return a.eisaiName.localeCompare(b.eisaiName);
					});

					// 将排序后的数据赋值给 nameOption
					this.nameOption = sortedData.map(obj => ({
						label: obj.eisaiName,
						...obj
					}));
				} else {
					this.$message.error(res.message);
				}
			},
			/* props => 生产厂家模糊查询 */
			searchMethod(query, option) {
				console.log(query);
				if (query) {
					console.log(query, '再调一次接口查询');
					this.inputSearchValue = query
					this.pageNum = 1
					this.pageSize = 10
					this.eisaiName = query
					this.getProData();
				} else {
					console.log('buzou');
				}
			},
			// select聚焦
			async handlefoucs(val, i) {
				this.idx = i;
				console.log(i);
				switch (i) {
					case 0: // 药典名称
						this.getProData();
						break;
				}
			},
			// 表格单选 => getPlan
			handleCurrentTableChange(val) {
				if (val.state != 5) {
					this.setCurrent();
					this.$message({
						type: 'error',
						message: '只能选择已过单数据!'
					});
				} else {
					// 赋id
					this.appId = val.id
					this.currentTable = val
					this.$message({
						type: 'success',
						message: '已选择:' + this.appId + '的采购计划数据'
					});
				}
			},
			// 取消高亮
			setCurrent(row) {
				this.$refs.singleTable.setCurrentRow(row);
			},
			// 表单头部聚焦事件 => addForm
			async sname(val, i) {
				// val.id = i;
				this.idx = i;
				console.log(i);
			},
			// 表单主体聚焦事件 => addMainForm
			async foucsSelect(v, i) {
				// val.id = i;
				this.idx = i;
				console.log(i);
				// i event
				switch (i) {
					case 0:
						// 卫材下拉选择框
						let res = await selectWCDrug()
						console.log(res.data.content)
						this.nameOption = res.data.content.map(obj => {
							// 将 name 替换为 label，并保留其他字段
							return {
								label: obj.eisaiName,
								...obj
							};
						});
						break;
				}
			},
			// 计算总金额
			getTotalAmt() {
				let cbTotal = 0;
				let lsTotal = 0;
				if (this.tableData.length === 0) {
					this.addForm.costAmt = this.addMainForm.retnAmt = this.addMainForm.retnPric * this.addMainForm
						.purcCnt // 成本金额
					this.addForm.saleAmt = this.addMainForm.saleAmt = this.addMainForm.salePric * this.addMainForm
						.purcCnt // 零售金额
					this.cbValue = this.addForm.costAmt;
					this.lsValue = this.addForm.saleAmt;
				} else {
					this.addForm.costAmt = this.addMainForm.retnAmt = this.addMainForm.retnPric * this.addMainForm
						.purcCnt // 成本金额
					this.addForm.saleAmt = this.addMainForm.saleAmt = this.addMainForm.salePric * this.addMainForm
						.purcCnt // 零售金额
					this.tableData.forEach(row => {
						cbTotal += row.retnAmt;
						lsTotal += row.saleAmt;
					});
					this.addForm.costAmt = this.cbValue = cbTotal;
					this.addForm.saleAmt = this.lsValue = lsTotal;
				}
			},
			handleInput(v, i) {
				this.idx = i;
				console.log(i);
				// i event
				switch (i) {
					case 11:
						this.getTotalAmt();
						break;
				}
			},
			// 调用接口查询是否可加入
			async isJoined() {
			  try {
			    // 检查是否已存在相同卫材ID
			    const exists = this.tableData.some(item => item.eisaiId === this.addMainForm.eisaiId);
			    if (exists) {
			      this.$message.error('该卫材已存在于列表中！');
			      return;
			    }
			
			    // 表单验证
			    const valid = await this.$refs.addMainForm.validate();
			    if (!valid) {
			      this.$message.error('请填写完整的卫材信息！');
			      return;
			    }
			
			    // 开始加载
			    this.loading = true;
			    this.$message.info('正在添加卫材...');
			
			    console.log('调用docOutWCJoin接口参数:', {
			      amount: this.addMainForm.retnCnt,
			      invId: this.addMainForm.invId,
			      purcType: this.purcType
			    });
			
			    // 调用接口
			    const result = await docOutWCJoin({
			      amount: this.addMainForm.retnCnt,
			      invId: this.addMainForm.invId,
			      purcType: this.purcType
			    });
			
			    console.log('接口返回结果:', result);
			
			    if (result.code === 200) {
			      // 关键修改：正确处理接口返回的对象数据
			      await this.processJoinResponse(result.data);
			      this.$message.success('卫材添加成功！');
			    } else {
			      this.$message.error(result.message || '添加失败');
			    }
			  } catch (error) {
			    console.error('加入失败:', error);
			    this.$message.error('添加失败: ' + (error.message || '网络错误'));
			  } finally {
			    // 关键修改：确保加载状态被关闭
			    this.loading = false;
			    this.$nextTick(() => {
			      this.loading = false; // 双重确保
			    });
			  }
			},
			// 修改：处理join接口返回数据 - 确保正确保存invId
			async processJoinResponse(responseData) {
			  try {
			    console.log('处理接口返回数据:', responseData);
			    
			    // 关键修改：安全处理tableData，确保是数组
			    if (!Array.isArray(this.tableData)) {
			      console.warn('tableData不是数组，重置为空数组');
			      this.tableData = [];
			    }
			    
			    // 处理返回的数据（可能是对象或数组）
			    let processedData = [];
			    
			    if (Array.isArray(responseData)) {
			      processedData = responseData;
			    } else if (typeof responseData === 'object' && responseData !== null) {
			      processedData = [responseData];
			    } else {
			      console.error('接口返回数据格式不正确:', responseData);
			      throw new Error('接口返回数据格式不正确');
			    }
			    
			    console.log('处理后的数据:', processedData);
			    
			    // 为每个数据项添加必要字段
			    const enhancedData = processedData.map((item, index) => {
			      const newItem = this.createTableItemFromJoinResponse(item, index);
			      return newItem;
			    });
			    
			    // 添加到表格数据
			    this.tableData = [...this.tableData, ...enhancedData];
			    
			    // 重新计算合计金额
			    this.calculateTotals();
			    
			    // 重置表单
			    this.resetDrugForm();
			    
			    console.log('添加完成，当前表格数据量:', this.tableData);
			    
			  } catch (error) {
			    console.error('处理接口返回数据失败:', error);
			    throw error;
			  }
			},
			// 修改：重置药品表单
			resetDrugForm() {
			  try {
			    // 保留必要的字段，重置其他字段
			    const currentEisaiId = this.addMainForm.eisaiId;
			    const currentEisaiName = this.addMainForm.eisaiName;
			    
			    this.addMainForm = {
			      // 保留药品基本信息，便于用户继续添加同类药品
			      eisaiId: currentEisaiId,
			      eisaiName: currentEisaiName,
			      
			      // 重置数量和相关字段
			      retnCnt: 1, // 重置为默认值1
			      purcCnt: 0,
			      purcPric: 0,
			      salePric: 0,
			      retnAmt: 0,
			      saleAmt: 0,
			      specDesc: '',
			      prodentpName: ''
			    };
			    
			    // 保持最小单位设置不变
			    this.purcType = '1';
			    this.addMainForm.purcType = '1';
			    this.addMainForm.unt = this.minUnt || '最小单位';
			    
			    // 重置表单验证
			    if (this.$refs.addMainForm) {
			      this.$nextTick(() => {
			        this.$refs.addMainForm.clearValidate();
			      });
			    }
			    
			    console.log('药品表单重置完成');
			  } catch (error) {
			    console.error('重置药品表单失败:', error);
			  }
			},
			// 新增：从join接口响应创建表格项
			createTableItemFromJoinResponse(joinItem, index) {
			  // 关键修改：正确保存join接口返回的invId和其他重要字段
			  const newItem = {
			    // 生成唯一ID
			    id: joinItem.id || `item_${Date.now()}_${index}`,
			    
			    // 卫材基本信息
			    eisaiId: this.addMainForm.eisaiId,
			    eisaiName: this.joinItem.eisaiName,
			    code: this.addMainForm.code,
			    specDesc: this.addMainForm.specDesc,
			    
			    // 关键修改1：正确保存invId - 优先使用join接口返回的invId
			    invId: this.getSafeNumber(joinItem.invId || this.addMainForm.invId),
			    invyId: this.getSafeNumber(joinItem.invyId || joinItem.invId || this.addMainForm.invId),
			    
			    // 库存和出库信息
			    purcCnt: this.getSafeNumber(joinItem.purcCnt || this.addMainForm.purcCnt, 0),
			    
			    // 关键修改2：使用retnCnt字段（后续会映射为retnCnt）
			    retnCnt: this.getSafeNumber(this.addMainForm.retnCnt, 1),
			    
			    purcType: this.purcType,
			    
			    // 价格信息
			    purcPric: this.getSafeNumber(joinItem.purcPric || this.addMainForm.purcPric, 0),
			    salePric: this.getSafeNumber(joinItem.purcPric || this.addMainForm.purcPric, 0),
			    
			    // 金额信息
			    retnAmt: this.calculateCostAmount(joinItem),
			    saleAmt: this.calculateCostAmount(joinItem),
			    
			    // 单位信息
			    unt: this.addMainForm.unt,
			    dosUnt: this.dosUnt,
			    pacUnt: this.unt,
			    
			    // 生产信息
			    prodentpName: this.addMainForm.prodentpName,
			    
			    // 关键修改3：保存完整的join接口返回数据
			    joinData: { ...joinItem }, // 保存完整的返回数据
			    
			    // 状态信息
			    editing: false,
			    hasJoinWarning: false,
			    isError: false,
			    availableQuantity: this.getSafeNumber(joinItem.availableQuantity, 0)
			  };
			  
			  console.log(`从join响应创建表格项 ${index}:`, {
			    原始join数据: joinItem,
			    创建的表格项: newItem,
			    invId来源: joinItem.invId ? 'join接口' : '表单',
			    invId值: newItem.invId
			  });
			  
			  return newItem;
			},
			// 新增：计算成本金额（使用接口返回的retnAmt）
			calculateCostAmount(item) {
			  try {
			    // 关键修改：优先使用接口返回的retnAmt
			    if (item.retnAmt !== undefined && item.retnAmt !== null) {
			      const cost = this.getSafeNumber(item.retnAmt, 0);
			      console.log('使用接口返回的retnAmt计算成本金额:', cost);
			      return cost;
			    }
			    
			    // 如果没有retnAmt，使用单价×数量计算
			    const price = this.getSafeNumber(item.purcPric || this.addMainForm.purcPric, 0);
			    const quantity = this.getSafeNumber(this.addMainForm.retnCnt, 1);
			    const amount = price * quantity;
			    
			    console.log('使用单价×数量计算成本金额:', { price, quantity, amount });
			    return amount;
			  } catch (error) {
			    console.error('计算成本金额失败:', error);
			    return 0;
			  }
			},
			
			// 新增：计算销售金额
			calculateSaleAmount(item) {
			  try {
			    const price = this.getSafeNumber(item.salePric || this.addMainForm.salePric, 0);
			    const quantity = this.getSafeNumber(this.addMainForm.retnCnt, 1);
			    const amount = price * quantity;
			    return amount;
			  } catch (error) {
			    console.error('计算销售金额失败:', error);
			    return 0;
			  }
			},
			// 库存类型选择
			SelectedPurcType(val) {
				this.addMainForm.purcType = val
				console.log(this.addMainForm.purcType, 'this.addMainForm.purcTypethis.addMainForm.purcType');
				if (this.addMainForm.purcType == 1) {
					this.addMainForm.retnCnt = this.addMainForm.retnCnt * this.getMinMax // 最小单位成本单价
				} else {
					this.addMainForm.retnCnt = this.addMainForm.retnCnt / this.getMinMax; // 最大单位成本单价
					// 验证 retnCnt 是否为非0正整数
					if (this.addMainForm.retnCnt) {
						const regex = /^[1-9][0-9]*$/; // 非0正整数正则表达式

						if (!regex.test(this.addMainForm.retnCnt)) {
							this.$message({
								type: 'error',
								message: '入库数量的最大单位必须是非0正整数!'
							});
							this.addMainForm.retnCnt = ''
							return; // 如果验证失败，直接返回不执行后续逻辑
						}
					}
				}
			},
			gotoPrice(v) {
				if (v.length > 5) {
					this.$message({
						type: 'error',
						message: '有效数量长度最高暂时为5位数...'
					});
				} else if (this.purcType == 1) {
					console.log(this.purcType, '输入数量leix'); // 最小单位成本单价
				}
			},
			// 查看单据数据
			watchData() {
				this.$message({
					type: 'waring',
					message: '正在开发中...'
				});
			},
			// 当前日期时间
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 将当前日期时间设置为夜晚十一点五十九分
			getNowDateTime() {
				// 获取当前日期时间
				this.addForm.busDate = this.formatDate(new Date);
				this.addForm.createTime = this.formatDate(new Date);
				// this.addForm.createTime = this.formatDate(new Date);
				// 获取制单人 => 当前登录用户
				this.addForm.createId = JSON.parse(localStorage.getItem('userInfo')).userId;
				this.addForm.creater = JSON.parse(localStorage.getItem('userInfo')).staffName;
				// 获取诊所Id => 当前登录用户
				this.addMainForm.clinicId = JSON.parse(localStorage.getItem('userInfo')).clinicId;
				// 获取终端序号 => 当前登录用户
				this.addForm.terminalId = localStorage.getItem('terminalId');
			},
			// 开始时间变化值
			startDateHandle(value) {
				if (value) {
					this.startDate = this.formatDate(value)
				}
			},
			// 结束时间变化值
			endDateHandle(value) {
				if (value) {
					this.endDate = this.formatDate(value)
				}
			},
			// 时间处理
			changDate(val) {
				let i = this.idx
				switch (i) {
					case 5:
						function formatDate(date) {
							const year = date.getFullYear();
							const month = (date.getMonth() + 1).toString().padStart(2, '0');
							const day = date.getDate().toString().padStart(2, '0');
							return `${year}-${month}-${day}`;
						}
						// 使用示例
						const now = new Date();
						this.addForm.busDate = formatDate(val);
				}
			},
			// 出库方式下拉列表
			async ckWays() {
				let rs = await getTretn();
				this.ckWaysOptions = rs.data.map(obj => {
					// 将 name 替换为 label，并保留其他字段
					return {
						label: obj.name,
						...obj
					};
				});
				console.log(this.ckWaysOptions, 'pppppppppppp');
			},
			// 供应商下拉列表
			async getGys() {
				let rs = await selectDropDownList()
				this.gysOption = rs.data.content.map(obj => {
					// 将 name 替换为 label，并保留其他字段
					return {
						label: obj.supplierName,
						...obj
					};
				});
			},
			// 下拉选项清空事件
			clearSelect() {
				this.getProData();
			},
			// 新增：使用选中的数据填充表单
			async fillWithSelectedData(selectedData) {
				try {
					this.isLoading = true;

					// 清空现有数据
					this.resetAllForms();

					// 设置模式为新增
					this.mode = 'add';

					// 遍历选中的数据，调用join接口获取详情
					for (const row of selectedData) {
						await this.loadRowDetailForReturn(row.id);
					}

					this.$message.success(`成功加载 ${selectedData.length} 条入库单数据`);
				} catch (error) {
					console.error('填充选中数据失败:', error);
					this.$message.error('加载数据失败');
				} finally {
					this.isLoading = false;
				}
			},
			// 修改：join接口调用方法，确保参数正确
			async callJoinInterface(interfaceParams) {
				try {
					this.interfaceLoading = true;
					this.loadingText = '正在调用接口处理数据...';

					// 关键修改：确保参数正确传递，使用外层ID
					const apiParams = {
						id: interfaceParams.sourceDocId, // 使用来源单ID
						eisaiId: interfaceParams.eisaiId,
						retnCnt: interfaceParams.retnCnt || 1,
						// 其他必要参数...
						...interfaceParams
					};

					console.log('调用join接口参数:', apiParams);

					const response = await docOutWCJoin(apiParams);

					if (response.code === 200) {
						// 处理成功响应
						this.handleJoinSuccess(response.data);
						return {
							success: true,
							data: response.data
						};
					} else {
						console.error('接口调用失败:', response.message);
						this.$message.error(`接口调用失败: ${response.message}`);
						// 保持对话框打开状态
						return {
							success: false,
							error: response.message
						};
					}
				} catch (error) {
					console.error('调用join接口失败:', error);
					this.$message.error('网络错误，请重试');
					// 保持对话框打开状态
					return {
						success: false,
						error: error.message
					};
				} finally {
					this.interfaceLoading = false;
					this.loadingText = '';
				}
			},

			// 新增：处理join接口成功响应
			handleJoinSuccess(data) {
				// 将返回的数据填充到表格
				if (data && data.list) {
					data.list.forEach(item => {
						this.tableData.push(this.processJoinResponseItem(item));
					});

					// 重新计算金额
					this.calculateTotals();

					this.$message.success('数据填充完成');
				}
			},
			// 新增：手动重新验证库存
			async revalidateStock(row) {
				try {
					this.$set(row, 'validating', true);

					const result = await this.callDocOutJoinForValidation(row);

					if (result.success) {
						row.availableQuantity = result.data.availableQuantity || row.purcCnt;
						row.hasJoinWarning = false;
						row.joinError = null;
						row.joinData = result.data;

						this.$message.success('库存验证成功');
					} else {
						row.hasJoinWarning = true;
						row.joinError = result.error;
						this.$message.warning('库存验证失败，请手动检查');
					}
				} catch (error) {
					console.error('重新验证库存失败:', error);
					this.$message.error('库存验证异常');
				} finally {
					this.$set(row, 'validating', false);
				}
			},

			// 新增：批量重新验证所有卫材库存
			async revalidateAllStock() {
				try {
					this.loadingText = '正在重新验证所有卫材库存...';
					let successCount = 0;
					let errorCount = 0;

					for (let i = 0; i < this.tableData.length; i++) {
						const row = this.tableData[i];

						if (row.isError) {
							continue; // 跳过错误行
						}

						try {
							this.loadingText = `正在验证卫材 ${i + 1}/${this.tableData.length}...`;

							const result = await this.callDocOutJoinForValidation(row);

							if (result.success) {
								row.availableQuantity = result.data.availableQuantity || row.purcCnt;
								row.hasJoinWarning = false;
								row.joinError = null;
								row.joinData = result.data;
								successCount++;
							} else {
								row.hasJoinWarning = true;
								row.joinError = result.error;
								errorCount++;
							}

							// 更新界面
							this.$set(this.tableData, i, row);

						} catch (error) {
							console.error(`验证卫材 ${i} 失败:`, error);
							errorCount++;
						}

						// 添加延迟避免接口频繁调用
						if (i < this.tableData.length - 1) {
							await new Promise(resolve => setTimeout(resolve, 200));
						}
					}

					if (errorCount === 0) {
						this.$message.success(`所有卫材库存验证成功（共 ${successCount} 条）`);
					} else {
						this.$message.warning(`库存验证完成：成功 ${successCount} 条，失败 ${errorCount} 条`);
					}

				} catch (error) {
					console.error('批量验证库存失败:', error);
					this.$message.error('批量验证库存异常');
				} finally {
					this.loadingText = '';
				}
			},
			// 修改： 处理退库数量变化
			handleRetnCntChange(row) {
				try {
					if (row.isError) {
						this.$message.warning('该卫材数据处理失败，无法修改数量');
						return;
					}

					// 确保是数字
					row.retnCnt = this.getNumberValue(row.retnCnt, 1);

					// 验证不能小于1
					if (row.retnCnt < 1) {
						row.retnCnt = 1;
						this.$message.warning('退库数量不能小于1');
						return;
					}

					// 关键修改：验证不能大于可退库数量
					const availableQty = row.availableQuantity || row.purcCnt;
					if (row.retnCnt > availableQty) {
						row.retnCnt = availableQty;
						this.$message.warning(`退库数量不能大于可退库数量（${availableQty}）`);
						return;
					}

					// 验证不能大于库存数量
					if (row.retnCnt > row.purcCnt) {
						row.retnCnt = row.purcCnt;
						this.$message.warning(`退库数量不能大于库存数量（${row.purcCnt}）`);
						return;
					}

					// 重新计算金额
					row.retnAmt = this.calculateAmount(row.retnPric, row.retnCnt);
					row.saleAmt = this.calculateAmount(row.salePric, row.retnCnt);

					// 更新合计金额
					this.calculateTotals();

				} catch (error) {
					console.error('处理退库数量变化失败:', error);
					this.$message.error('处理数量变化失败');
				}
			},
			handleReturn() {
			  // 检查是否有未保存的数据
			  if (this.hasUnsavedChanges()) {
			    this.$confirm('关闭此界面会清空现已选择的内容, 是否继续?', '提示', {
			      confirmButtonText: '确定',
			      cancelButtonText: '取消',
			      type: 'warning'
			    }).then(() => {
			      this.resetAllForms();
			      this.$emit('close');
			    }).catch(() => {
			      this.$message.info('已取消关闭');
			    });
			  } else {
			    // 如果没有数据，直接关闭
			    this.$emit('close');
			  }
			},
			
			// 新增：检查是否有未保存的更改
			hasUnsavedChanges() {
			  // 检查基本信息表单
			  if (this.addForm) {
			    const basicFields = [
			      'supplyCandidateId', 'shedId', 'retnTypeId', 
			      'busDate', 'remark'
			    ];
			    
			    for (const field of basicFields) {
			      if (this.addForm[field] && this.addForm[field] !== '') {
			        return true;
			      }
			    }
			  }
			  
			  // 检查卫材明细表单
			  if (this.addMainForm) {
			    const detailFields = [
			      'eisaiId', 'eisaiName', 'apllyAmt', 'retnPric', 
			      'salePric', 'manuLotnum'
			    ];
			    
			    for (const field of detailFields) {
			      if (this.addMainForm[field] && this.addMainForm[field] !== '' && this.addMainForm[field] !== 0) {
			        return true;
			      }
			    }
			  }
			  
			  // 检查已选卫材列表
			  if (this.tableData && this.tableData.length > 0) {
			    return true;
			  }
			  
			  return false;
			},
			// 新增：加载行详情数据用于退库
			async loadRowDetailForReturn(rowId) {
				try {
					// 调用join接口获取详情
					const response = await getRetnDetail({
						id: rowId
					});

					if (response.code === 200 && response.data) {
						// 处理返回的数据并填充到表格
						await this.processReturnData(response.data);
						return true;
					} else {
						this.$message.error(`获取入库单详情失败: ${response.message}`);
						return false;
					}
				} catch (error) {
					console.error(`加载入库单 ${rowId} 详情失败:`, error);
					this.$message.error('获取数据失败');
					return false;
				}
			},

			// 新增：处理退库数据
			async processReturnData(returnData) {
				// 填充基本信息
				this.addForm = {
					...this.addForm,
					busDate: new Date().toISOString().split('T')[0],
					supplierId: returnData.supplyCandidateId,
					supplierName: returnData.supplierName,
					remark: `来源于入库单: ${returnData.docNum}`
				};

				// 处理卫材明细
				if (returnData.list && Array.isArray(returnData.list)) {
					for (const item of returnData.list) {
						const newRow = this.createReturnRowFromItem(item, returnData);
						this.tableData.push(newRow);
					}
				}

				// 重新计算金额
				this.calculateTotals();
			},

			// 新增：从接口数据创建退库行
			createReturnRowFromItem(item, sourceData) {
				return {
					id: item.id || Date.now(),
					eisaiId: item.eisaiId,
					eisaiName: item.eisaiName,
					drugCode: item.drugCode,
					drugSpecifications: item.drugSpecifications,
					purcCnt: item.purcCnt || 0, // 库存数量
					retnCnt: 1, // 默认退库数量为1
					retnPric: item.purcPric || 0, // 成本单价
					salePric: item.salePric || 0, // 零售单价
					retnAmt: item.purcPric || 0, // 成本金额
					saleAmt: item.salePric || 0, // 零售金额
					manuLotnum: item.manuLotnum,
					manuDate: item.manuDate,
					expyDate: item.expyDate,
					prodentpName: item.prodentpName,
					sourceDocNum: sourceData.docNum, // 来源单号
					sourceDocId: sourceData.id,
					editing: false
				};
			},
			handleInputPacCut(v, i) {
				this.idx = i;
				console.log(i);
				// i event
				switch (i) {
					case 8:
						let purcCntRule = /^[1-9]\d*$/;
						if (!purcCntRule.test(this.addMainForm.purcCnt)) {
							this.$message({
								type: 'error',
								message: '请输入正确的出库数量，请注意格式!'
							});
						} else {
							this.getMarkUpPric();
							this.getPageListCheck(); // 检测库存是否充足
						}
						break;
				}
			},
			// 直接计算销售金
			getMarkUpPric(drugrs) {
				this.addForm.costAmt = this.addMainForm.retnPric * Number(this.addMainForm.retnCnt) // 成本金额
				this.addForm.saleAmt = this.addMainForm.salePric * Number(this.addMainForm.retnCnt); // 零售金额
				this.addMainForm.retnAmt = this.addMainForm.retnPric * Number(this.addMainForm.retnCnt) // 成本金额 =》 明细
				this.addMainForm.saleAmt = this.addMainForm.salePric * Number(this.addMainForm.retnCnt); // 零售金额 =》 明细
				// console.log(this.addMainForm.retnPric,'怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕怕',this.addMainForm.retnCnt);
				this.cbValue = this.addForm.costAmt
				this.lsValue = this.addForm.saleAmt
			},
			// SelectVal to editForm
			handleChange(val) {
				console.log(val);
				if (val) {
					this.disabled = false
				}
				// i event
			},
			handleChangeDrug(val) {
				let drugrs = this.nameOption.find(name => name.id === val)
				console.log(drugrs, 'drugrsdrugrsdrugrs');
				this.getMinMax = drugrs.pacCnt // 大小单位转换
				// this.addMainForm.id = drugrs.eisaiId
				this.addMainForm.label = drugrs.eisaiName
				this.addMainForm.purcCnt = drugrs.purcCnt
				this.addMainForm.drugCode = drugrs.drugCode
				this.addMainForm.invId = drugrs.id
				// this.addMainForm.eisaiId = drugrs.eisaiId
				this.addMainForm.manuLotnum = drugrs.manuLotnum
				this.addMainForm.specDesc = drugrs.specDesc
				this.addMainForm.retnPric = drugrs.purcPric
				this.KcNum = drugrs.purcCnt // 库存数量
				this.unt = drugrs.pacUnt // 包装单位
				this.purcType = '2';
				this.minUnt = drugrs.dosUnt // 最小单位
				this.addMainForm.salePric = drugrs.salePric
				this.dosUnt = this.addMainForm.unt = drugrs.unt
				this.addMainForm.prodentpName = drugrs.prodentpName
				this.addMainForm.prodentpId = drugrs.prodentpNameId
				this.packNum = drugrs.pacCnt // 包装数量
			},
			prepareAddOutboundData() {
			  const formData = {
			    costAmt: this.getSafeNumber(this.addForm.costAmt, 0),
			    remarks: this.addForm.remark || '',
			    retnTypeId: this.getSafeNumber(this.addForm.retnTypeId, 11),
			    saleAmt: this.getSafeNumber(this.addForm.saleAmt, 0),
			    shedId: this.getSafeNumber(this.addForm.shedId, 1),
			    state: this.getSafeNumber(this.addForm.state, 0),
			    supplyCandidateId: this.getSafeNumber(this.addForm.supplyCandidateId),
			    // 如果是编辑模式，传递id
			    ...(this.mode === 'edit' && this.currentRow && this.currentRow.id ? { id: this.currentRow.id } : {})
			  };
			
			  // 关键修改：确保list中的invId正确
			  formData.list = this.tableData.map(item => {
			    const rowData = {
			      apllyAmt: this.getSafeNumber(item.apllyAmt, 0), // 使用apllyAmt
			      eisaiId: this.getSafeNumber(item.eisaiId),
			      eisaiName: item.eisaiName || '',
			      specDesc: item.specDesc || item.drugSpecifications || '',
			      // 关键修改：确保invId正确传递
			      invId: this.getSafeNumber(item.invId || item.invyId),
			      manuLotnum: item.manuLotnum || '',
			      prodentpName: item.prodentpName || '',
			      prodentpNameId: this.getSafeNumber(item.prodentpNameId),
			      purcType: this.getSafeNumber(item.purcType, 2),
			      retnAmt: this.getSafeNumber(item.retnAmt, 0),
			      retnPric: this.getSafeNumber(item.retnPric, 0),
			      saleAmt: this.getSafeNumber(item.saleAmt, 0),
			      salePric: this.getSafeNumber(item.salePric, 0),
			      unt: item.unt || (item.purcType === '1' ? item.dosUnt : item.pacUnt) || '个'
			    };
			    
			    // 如果是编辑模式，传递明细id（如果存在）
			    if (this.mode === 'edit' && item.id && typeof item.id === 'number') {
			      rowData.id = item.id;
			    }
			    
			    console.log('准备提交的卫材明细:', {
			      卫材名称: rowData.eisaiName,
			      invId: rowData.invId,
			      数量: rowData.apllyAmt
			    });
			    
			    return rowData;
			  }).filter(item => item.eisaiId > 0); // 过滤无效数据
			
			  console.log('准备提交的接口数据（编辑模式）:', {
			    模式: this.mode,
			    单据ID: formData.id,
			    列表长度: formData.list.length,
			    列表数据: formData.list
			  });
			  
			  return formData;
			},
			
			// 修改：新增保存方法
			async addSubmit() {
			  try {
			    // 触发表单验证
			    await this.$refs.addForm.validate();
			
			    // 检查是否有卫材明细
			    if (this.tableData.length === 0) {
			      this.$message.error('请至少添加一条卫材明细');
			      return;
			    }
			
			    // 准备接口数据
			    const submitData = this.prepareAddOutboundData();
			    
			    // 设置状态为已提交
			    submitData.state = 2;
			
			    console.log('提交采购出库数据:', submitData);
			
			    // 调用接口
			    const result = await addWCOutbound(submitData);
			
			    if (result.code === 200) {
			      this.$message.success(result.message || '新增成功');
			      
			      // 直接关闭模态框，不显示关闭提示
			      this.$emit('refresh'); // 触发父组件刷新
			      this.$emit('close');   // 关闭模态框
			    } else {
			      this.$message.error(result.message || '保存失败');
			    }
			  } catch (error) {
			    console.error('保存失败:', error);
			    if (error instanceof Error) {
			      // 如果是验证错误，不显示消息
			      return;
			    }
			    this.$message.error('保存失败，请检查表单数据');
			  }
			},
			checkedNum() {
				if (this.addMainForm.purcType == 1) {
					this.addMainForm.retnCnt = this.addMainForm.retnCnt
				} else {
					this.addMainForm.retnCnt = Number(this.addMainForm.retnCnt) * this.packNum
				}
			},
			// 草稿保存
			async draftSubmit() {
			  try {
			    // 触发表单验证
			    await this.$refs.addForm.validate();
			
			    // 检查是否有卫材明细
			    if (this.tableData.length === 0) {
			      this.$message.error('请至少添加一条卫材明细');
			      return;
			    }
			
			    // 准备接口数据
			    const submitData = this.prepareAddOutboundData();
			    
			    // 设置状态为草稿
			    submitData.state = 0;
			
			    const result = await addWCOutbound(submitData);
			
			    if (result.code === 200) {
			      this.$message.success(result.message || '草稿保存成功');
			      
			      // 直接关闭模态框，不显示关闭提示
			      this.$emit('refresh'); // 触发父组件刷新
			      this.$emit('close');   // 关闭模态框
			    } else {
			      this.$message.error(result.message || '草稿保存失败');
			    }
			  } catch (error) {
			    console.error('草稿保存失败:', error);
			    if (error instanceof Error) {
			      return;
			    }
			    this.$message.error('草稿保存失败');
			  }
			},
			// 修改草稿保存
			async draftEditSubmit() {
				console.log(this.addForm, 'this.addFormthis.addFormthis.addForm');
				//触发验证表单
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						this.addForm.state = 0
						this.addForm.list = this.tableData
						let result = await editWCdocOut(this.addForm)
						if (result.code === 200) {
							this.$message({
								type: 'success',
								message: result.message
							});
							this.handleReturn();
						} else {
							this.$message.error(result.message)
						}
					}
				})
			},
			// 加载行数据（编辑/查看模式）
			loadRowData() {
				if (this.currentRow) {
					// 加载数据
					this.addForm = {
						...this.currentRow
					};
					this.tableData = this.currentRow.list || [];

					// 计算总金额
					this.calculateTotals();

					// 设置编辑状态
					this.isEditShow = this.mode === 'edit';
				}
			},
			// 根据选择的id去查找id对应的对象
			foundObj() {
				let rs = this.gysOption.find(name => name.id === val)
			},
			// 删除行（修正版本）
			deleteRow(index) {
				this.$confirm('确定要删除此行吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 确保tableData存在且是数组
					if (Array.isArray(this.tableData)) {
						this.tableData.splice(index, 1);
						this.$message.success('删除成功');
						// 重新计算合计
						this.calculateTotals();
					} else {
						this.$message.error('数据异常，无法删除');
					}
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			handleSelectCost(val) {
				this.addForm.nativePlace = val.join(',')
			},
			// db events
			// 给单元格绑定横向和竖向的index，这样就能确定是哪一个单元格
			tableCellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				row.index = rowIndex;
				column.index = columnIndex;
			},
			// 当input失去焦点的时候，隐藏input
			hideInput() {
				this.currentCell = null;
			},
			// 获得当前双击的单元格的横竖index，然后拼接成一个唯一字符串用于判断，并赋给currentCell  // 拼接后类似这样："1,0","1,1",
			dbclick(row, column) {
				console.log(column.index);
			},
			// db events
			handledbRow(row, column, event) {
				if (row) {
					this.addForm = row;
					this.watchDialogVisible = true
				} else {
					console.log('fail');
				}
				// console.log(this.addForm);
				this.formdisabled = true
			},
			// col 里面包含了表头字段和名称，list 是表格数据
			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 40; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop]
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 24; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 12;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 8;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},
			// 挂载或销毁前后重新赋值后端参数
			getAddForm() {
				// 左侧提交表单
				this.addForm = addForm.map(v => {
					return v
				})[0]; // Form
				this.addMainForm = this.addForm.list[0]
				console.log(this.addForm, '原始的接口参数数据');
				// 定义数据来源
				this.formType = AccType.map(function(val) {
					return val
				})
				this.formMainType = AccMainType.map(function(val) {
					return val
				})
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
				this.loadData();
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.loadData();
			},
			// 库存序号判断
			async getPageListCheck() {
				if (this.addMainForm.eisaiId == '') {
					this.$message({
						type: 'error',
						message: '请先选择正确的卫材信息!'
					});
				} else if (this.addMainForm.prodentpNameId == '') {
					this.$message({
						type: 'error',
						message: '关联的厂家序号错误，请重试。'
					});
				} else if (this.addMainForm.purcCnt > this.KcNum) {
					// this.$message({ type: 'error', message: '调拨数量不能大于当前库存数量！【当前库存数量】：'+this.KcNum});
					this.$confirm('调拨数量不能大于【当前库存数量】！', '提示', {
						confirmButtonText: 'OK',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
					this.addMainForm.purcCnt = 1;
				}
			},
			// 启用编辑状态 - 确保初始值正确
			enableEditing(row) {
			  if (row.isError) {
			    this.$message.warning('错误行无法编辑');
			    return;
			  }
			
			  // 先取消其他行的编辑状态
			  this.tableData.forEach(item => {
			    if (item.editing && item !== row) {
			      this.$set(item, 'editing', false);
			    }
			  });
			
			  // 保存原始数据
			  this.$set(row, '_originalData', { 
			    ...row,
			    // 特别保存原始的出库数量
			    originalApllyAmt: row.apllyAmt
			  });
			  
			  // 确保出库数量是有效的
			  if (!row.apllyAmt || row.apllyAmt <= 0) {
			    row.apllyAmt = 1;
			  }
			  
			  this.$set(row, 'editing', true);
			  this.isEditing = true;
			  
			  console.log('启用编辑状态，当前行:', {
			    模式: this.mode,
			    卫材名称: row.eisaiName,
			    出库数量: row.apllyAmt,
			    库存数量: row.purcCnt
			  });
			},
			// 新增：失焦验证出库数量
			validateAmountOnBlur(row) {
			  try {
			    if (!row.editing) return;
			    
			    console.log('失焦验证，当前行:', {
			      模式: this.mode,
			      卫材名称: row.eisaiName,
			      出库数量: row.apllyAmt
			    });
			    
			    // 确保是数字
			    const amount = this.getSafeNumber(row.apllyAmt, 1);
			    row.apllyAmt = amount;
			    
			    // 验证不能小于1
			    if (amount < 1) {
			      row.apllyAmt = 1;
			      this.$message.warning('出库数量不能小于1');
			      return;
			    }
			    
			    // 编辑模式下只验证正整数
			    if (this.mode === 'edit') {
			      // 验证是否为整数
			      if (!Number.isInteger(amount)) {
			        row.apllyAmt = Math.floor(amount);
			        this.$message.warning('出库数量已自动调整为整数');
			        return;
			      }
			      
			      console.log('编辑模式失焦验证通过');
			    } else {
			      // 新增模式：验证出库数量不能大于可出库数量
			      const availableQty = row.availableQuantity || row.purcCnt;
			      if (amount > availableQty) {
			        row.apllyAmt = availableQty;
			        this.$message.warning(`出库数量不能大于可出库数量（${availableQty}）`);
			        return;
			      }
			    }
			    
			  } catch (error) {
			    console.error('失焦验证失败:', error);
			  }
			},
			async saveEdit(row) {
			  try {
			    console.log('=== 开始保存编辑 ===');
			    console.log('保存前的行数据:', {
			      模式: this.mode,
			      卫材名称: row.eisaiName,
			      出库数量: row.apllyAmt,
			      库存ID: row.invId || row.invyId
			    });
			
			    // 验证出库数量
			    if (!row.apllyAmt || row.apllyAmt <= 0) {
			      this.$message.error('出库数量必须大于0');
			      return;
			    }
			
			    // 验证是否为整数
			    if (!Number.isInteger(row.apllyAmt)) {
			      this.$message.error('出库数量必须为整数');
			      return;
			    }
			
			    // 区分编辑模式和新增模式
			    if (this.mode === 'edit') {
			      // 编辑模式：直接调用docOutWCJoin接口
			      await this.saveEditWithDocOutJoin(row);
			    } else {
			      // 新增模式：保持原有逻辑
			      await this.saveEditForAddMode(row);
			    }
			    
			  } catch (error) {
			    console.error('保存编辑失败:', error);
			    this.$message.error('保存失败: ' + (error.message || '未知错误'));
			  }
			},
			
			// 新增：编辑模式下调用docOutWCJoin接口保存
			async saveEditWithDocOutJoin(row) {
			  try {
			    // 准备调用docOutWCJoin接口的参数
			    const joinParams = {
			      amount: row.apllyAmt, // 出库数量
			      invId: row.invId || row.invyId, // 库存ID
			      pacCnt: row.pacCnt || 1, // 包装数量
			      purcType: row.purcType || '2' // 库存类型
			    };
			
			    console.log('调用docOutWCJoin接口参数:', joinParams);
			
			    // 调用docOutWCJoin接口
			    const result = await docOutWCJoin(joinParams);
			
			    if (result.code === 200) {
			      console.log('docOutWCJoin接口调用成功:', result.data);
			      
			      // 更新行数据
			      if (result.data) {
			        // 更新可出库数量
			        if (result.data.availableQuantity !== undefined) {
			          row.availableQuantity = result.data.availableQuantity;
			        }
			        
			        // 更新库存数量
			        if (result.data.purcCnt !== undefined) {
			          row.purcCnt = result.data.purcCnt;
			        }
			        
			        // 更新其他可能返回的字段
			        Object.assign(row, result.data);
			      }
			      
			      // 重新计算金额
			      row.retnAmt = this.calculateAmount(row.retnPric, row.apllyAmt);
			      row.saleAmt = this.calculateAmount(row.salePric, row.apllyAmt);
			      
			      // 退出编辑状态
			      this.$set(row, 'editing', false);
			      if (row._originalData) {
			        delete row._originalData;
			      }
			      this.isEditing = false;
			      
			      // 更新合计
			      this.calculateTotals();
			      
			      this.$message.success('保存成功');
			      
			      console.log('保存成功后的行数据:', row);
			      
			    } else {
			      this.$message.error(result.message || '保存失败');
			    }
			    
			  } catch (error) {
			    console.error('调用docOutWCJoin接口失败:', error);
			    throw error;
			  }
			},
			
			// 新增：新增模式的保存逻辑
			async saveEditForAddMode(row) {
			  // 新增模式：验证出库数量不能大于可出库数量
			  const availableQty = row.availableQuantity || row.purcCnt;
			  if (row.apllyAmt > availableQty) {
			    this.$message.error(`出库数量不能大于可出库数量（${availableQty}）`);
			    return;
			  }
			  
			  // 重新计算金额
			  row.retnAmt = this.calculateAmount(row.retnPric, row.apllyAmt);
			  row.saleAmt = this.calculateAmount(row.salePric, row.apllyAmt);
			  
			  // 退出编辑状态
			  this.$set(row, 'editing', false);
			  if (row._originalData) {
			    delete row._originalData;
			  }
			  this.isEditing = false;
			  
			  // 更新合计
			  this.calculateTotals();
			  
			  this.$message.success('保存成功');
			},
			
			// 新增：从DOM获取当前输入值的方法
			getCurrentInputValue(row) {
			  try {
			    // 查找当前行的输入框
			    const inputs = document.querySelectorAll(`.el-input__inner[data-row-id="${row.id}"]`);
			    if (inputs && inputs.length > 0) {
			      const value = inputs[0].value;
			      console.log('从DOM获取输入值:', value);
			      return this.parseNumberSafely(value);
			    }
			    
			    // 如果没有找到特定标识的输入框，尝试通过其他方式
			    const table = document.querySelector('.el-table');
			    if (table) {
			      const rows = table.querySelectorAll('tr');
			      for (let i = 0; i < rows.length; i++) {
			        const inputs = rows[i].querySelectorAll('.el-input__inner');
			        for (let j = 0; j < inputs.length; j++) {
			          if (inputs[j].value) {
			            const val = this.parseNumberSafely(inputs[j].value);
			            if (!isNaN(val) && val > 0) {
			              console.log('从通用DOM获取输入值:', val);
			              return val;
			            }
			          }
			        }
			      }
			    }
			    
			    return null;
			  } catch (error) {
			    console.error('从DOM获取输入值失败:', error);
			    return null;
			  }
			},
			// 新增：安全的数值解析方法
			parseNumberSafely(value) {
			  if (value === null || value === undefined || value === '') {
			    return NaN;
			  }
			  
			  // 如果是数字类型，直接返回
			  if (typeof value === 'number') {
			    return isNaN(value) ? NaN : value;
			  }
			  
			  // 如果是字符串，尝试解析
			  if (typeof value === 'string') {
			    // 移除可能的空格
			    const trimmed = value.trim();
			    
			    // 如果是空字符串
			    if (trimmed === '') {
			      return NaN;
			    }
			    
			    // 尝试解析为数字
			    const num = Number(trimmed);
			    
			    // 检查是否有效数字
			    if (isNaN(num)) {
			      // 尝试提取数字（如果有非数字字符）
			      const match = trimmed.match(/[-+]?[0-9]*\.?[0-9]+/);
			      if (match) {
			        return Number(match[0]);
			      }
			      return NaN;
			    }
			    
			    return num;
			  }
			  
			  // 其他类型尝试转换
			  try {
			    const num = Number(value);
			    return isNaN(num) ? NaN : num;
			  } catch (e) {
			    return NaN;
			  }
			},
			// 取消编辑
			cancelEdit(row) {
			  console.log('取消编辑，恢复原始数据:', row._originalData);
			  
			  // 恢复原始数据
			  if (row._originalData) {
			    // 特别处理出库数量
			    if (row._originalData.originalApllyAmt !== undefined) {
			      row.apllyAmt = row._originalData.originalApllyAmt;
			    }
			    
			    // 恢复其他字段
			    const originalData = { ...row._originalData };
			    delete originalData.originalApllyAmt; // 删除临时字段
			    delete originalData._originalData;    // 删除自身引用
			    
			    Object.assign(row, originalData);
			    
			    // 重新计算金额
			    row.retnAmt = this.calculateAmount(row.retnPric, row.apllyAmt);
			    row.saleAmt = this.calculateAmount(row.salePric, row.apllyAmt);
			  }
			
			  // 退出编辑状态
			  this.$set(row, 'editing', false);
			  delete row._originalData;
			
			  // 启用底部按钮
			  this.isEditing = false;
			  
			  // 更新合计
			  this.calculateTotals();
			  
			  console.log('取消编辑完成，当前出库数量:', row.apllyAmt);
			},

			// 处理数量变化
			handleAmountChange(row) {
			  try {
			    if (row.isError) {
			      this.$message.warning('错误行无法修改数量');
			      return;
			    }
			
			    console.log('处理出库数量变化，当前行:', {
			      模式: this.mode,
			      卫材名称: row.eisaiName,
			      输入数量: row.apllyAmt,
			      当前类型: typeof row.apllyAmt
			    });
			
			    // 确保是数字
			    row.apllyAmt = this.getSafeNumber(row.apllyAmt, 1);
			
			    // 验证不能小于1
			    if (row.apllyAmt < 1) {
			      row.apllyAmt = 1;
			      this.$message.warning('出库数量不能小于1');
			      return;
			    }
			
			    // 关键修改：编辑模式下只验证正整数
			    if (this.mode === 'edit') {
			      // 验证是否为整数
			      if (!Number.isInteger(row.apllyAmt)) {
			        row.apllyAmt = Math.floor(row.apllyAmt);
			        this.$message.warning('出库数量必须为整数');
			        return;
			      }
			      
			      // 验证是否为正数
			      if (row.apllyAmt <= 0) {
			        row.apllyAmt = 1;
			        this.$message.warning('出库数量必须大于0');
			        return;
			      }
			      
			      console.log('编辑模式验证通过，出库数量:', row.apllyAmt);
			    } else {
			      // 新增模式：保持原有验证逻辑
			      const availableQty = row.availableQuantity || row.purcCnt;
			      if (row.apllyAmt > availableQty) {
			        row.apllyAmt = availableQty;
			        this.$message.warning(`出库数量不能大于可出库数量（${availableQty}）`);
			        return;
			      }
			    }
			
			    // 重新计算金额
			    row.retnAmt = this.calculateAmount(row.retnPric, row.apllyAmt);
			    row.saleAmt = this.calculateAmount(row.salePric, row.apllyAmt);
			
			    // 更新合计金额
			    this.calculateTotals();
			
			  } catch (error) {
			    console.error('处理出库数量变化失败:', error);
			    this.$message.error('处理数量变化失败');
			  }
			},

			// 修改：计算合计金额 - 修复reduce错误
			calculateTotals() {
			  try {
			    // 关键修改：确保tableData是数组
			    if (!Array.isArray(this.tableData)) {
			      console.warn('tableData不是数组，重置为空数组并清空合计');
			      this.tableData = [];
			      this.cbValue = '0.00';
			      this.lsValue = '0.00';
			      return;
			    }
			    
			    let costTotal = 0;
			    let saleTotal = 0;
			    
			    // 安全使用reduce
			    costTotal = this.tableData.reduce((total, item) => {
			      if (item.isError) return total;
			      const amount = this.getSafeNumber(item.retnAmt, 0);
			      return total + amount;
			    }, 0);
			    
			    saleTotal = this.tableData.reduce((total, item) => {
			      if (item.isError) return total;
			      const amount = this.getSafeNumber(item.saleAmt, 0);
			      return total + amount;
			    }, 0);
			    
			    this.cbValue = costTotal.toFixed(2);
			    this.lsValue = saleTotal.toFixed(2);
			    
			    // 更新表单中的总金额
			    this.addForm.costAmt = this.cbValue;
			    this.addForm.saleAmt = this.lsValue;
			    
			    console.log('计算合计完成:', {
			      成本合计: this.cbValue,
			      零售合计: this.lsValue,
			      物品数量: this.tableData.length
			    });
			    
			  } catch (error) {
			    console.error('计算合计金额失败:', error);
			    this.cbValue = '0.00';
			    this.lsValue = '0.00';
			  }
			},

			// 循环加入按钮点击事件
			clickEvents(val, i) {
				this.idx = i;
				switch (i) {
					case 7:
						// 如果是编辑状态，则更新当前编辑的行
						if (this.addMainForm.editing) {
							this.saveEdit(this.addMainForm);
						} else {
							// 否则正常加入新数据
							this.$refs.addMainForm.validate(async (valid) => {
								if (valid) {
									this.isJoined();
								}
							});
						}
						break;
				}
			},

			// 审核
			handleAudit() {
				this.$confirm('确定审核通过吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.auditData();
				}).catch(() => {});
			},

			// 审核数据
			async auditData() {
				try {
					if (!this.currentRow || !this.currentRow.id) {
						this.$message.error('无效的数据');
						return;
					}

					const params = {
						id: this.currentRow.id,
						state: 4 // 审核通过状态
					};

					const res = await toRetnWCExamine(params);
					if (res.code === 200) {
						this.$message.success('审核成功');
						this.$emit('refresh');
						this.$emit('close');
					} else {
						this.$message.error(res.message || '审核失败');
					}
				} catch (error) {
					console.error('审核失败:', error);
					this.$message.error('审核失败');
				}
			},

			// 过单
			handlePass() {
				this.$confirm('确定过单吗？过单后将完成整个流程', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.passData();
				}).catch(() => {});
			},

			// 过单数据
			async passData() {
				try {
					if (!this.currentRow || !this.currentRow.id) {
						this.$message.error('无效的数据');
						return;
					}

					const params = {
						id: this.currentRow.id,
						state: 5 // 已过单状态
					};

					const res = await toRetnWCExamine(params);
					if (res.code === 200) {
						this.$message.success('过单成功');
						this.$emit('refresh');
						this.$emit('close');
					} else {
						this.$message.error(res.message || '过单失败');
					}
				} catch (error) {
					console.error('过单失败:', error);
					this.$message.error('过单失败');
				}
			},

			// 反审核
			handleReverseAudit() {
				this.$confirm('确定要反审核吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.reverseAuditData();
				}).catch(() => {});
			},

			// 反审核数据
			async reverseAuditData() {
				try {
					if (!this.currentRow || !this.currentRow.id) {
						this.$message.error('无效的数据');
						return;
					}

					const params = {
						id: this.currentRow.id,
						state: 2 // 返回到待审核状态
					};

					const res = await toRetnWCExamine(params);
					if (res.code === 200) {
						this.$message.success('反审核成功');
						this.$emit('refresh');
						this.$emit('close');
					} else {
						this.$message.error(res.message || '反审核失败');
					}
				} catch (error) {
					console.error('反审核失败:', error);
					this.$message.error('反审核失败');
				}
			},
			
			async fillWithSelectedIds(selectedIds) {
			  try {
			    this.isLoading = true;
			    this.loadingText = '正在获取选中的入库单数据...';
			    
			    // 清空现有数据
			    this.resetAllForms();
			    
			    // 设置模式为新增
			    this.mode = 'add';
			    
			    console.log('开始加载选中的入库单ID:', selectedIds);
			    
			    // 使用Promise.all并行加载所有选中的入库单详情
			    const loadPromises = selectedIds.map(id => this.loadPurchaseDetailById(id));
			    const results = await Promise.all(loadPromises);
			    
			    // 统计成功加载的数量
			    const successCount = results.filter(result => result.success).length;
			    
			    if (successCount > 0) {
			      this.$message.success(`成功加载 ${successCount}/${selectedIds.length} 条入库单数据`);
			    } else {
			      this.$message.warning('未能成功加载任何入库单数据');
			    }
			    
			  } catch (error) {
			    console.error('填充选中数据失败:', error);
			    this.$message.error('加载数据失败');
			  } finally {
			    this.isLoading = false;
			    this.loadingText = '';
			  }
			},
			
			// 新增：根据ID加载采购入库单详情
			async loadPurchaseDetailById(purchaseId) {
			  try {
			    console.log(`正在加载入库单详情，ID: ${purchaseId}`);
			
			    // 调用获取采购入库详情接口
			    const response = await getDrugDetails({
			      id: purchaseId
			    });
			
			    if (response.code === 200 && response.data) {
			      console.log(`成功获取入库单 ${purchaseId} 的详情:`, response.data);
			      this.addForm.supplyCandidateId = response.data.supplyCandidateId;
			      // 处理返回的数据并填充到表格
			      await this.processPurchaseDetailForReturn(response.data);
			      return {
			        success: true,
			        id: purchaseId
			      };
			    } else {
			      console.error(`获取入库单 ${purchaseId} 详情失败:`, response.message);
			      this.$message.error(`获取入库单 ${purchaseId} 详情失败: ${response.message}`);
			      return {
			        success: false,
			        id: purchaseId,
			        error: response.message
			      };
			    }
			  } catch (error) {
			    console.error(`加载入库单 ${purchaseId} 详情失败:`, error);
			    this.$message.error(`加载入库单 ${purchaseId} 详情失败`);
			    return {
			      success: false,
			      id: purchaseId,
			      error: error.message
			    };
			  }
			},

			// 修改：处理采购入库单详情数据用于退库
			async processPurchaseDetailForReturn(purchaseDetail) {
			  try {
			    console.log('开始处理采购入库单详情:', purchaseDetail);
			
			    // 填充基本信息
			    this.fillBasicInfoFromPurchase(purchaseDetail);
			
			    // 关键修改：正确处理卫材明细列表
			    if (purchaseDetail.list && Array.isArray(purchaseDetail.list)) {
			      console.log(`获取到 ${purchaseDetail.list.length} 条卫材明细`);
			      
			      // 清空现有表格数据
			      this.tableData = [];
			      
			      // 顺序处理每个卫材明细，调用docOutWCJoin接口
			      await this.processDrugListForReturn(purchaseDetail.list, purchaseDetail);
			    } else {
			      console.warn('采购入库单没有卫材明细数据');
			      this.$message.warning('该入库单没有卫材明细数据');
			    }
			
			    console.log('卫材明细处理完成，表格数据量:', this.tableData.length);
			
			  } catch (error) {
			    console.error('处理采购入库单详情失败:', error);
			    throw error;
			  }
			},
			async editSubmit() {
			  try {
			    // 触发表单验证
			    await this.$refs.addForm.validate();
			
			    // 检查是否有卫材明细
			    if (this.tableData.length === 0) {
			      this.$message.error('请至少添加一条卫材明细');
			      return;
			    }
			
			    // 检查每个卫材明细的invId是否有效
			    const invalidItems = this.tableData.filter(item => 
			      !item.invId && !item.invyId
			    );
			    
			    if (invalidItems.length > 0) {
			      console.error('发现无效的卫材明细（缺少invId）:', invalidItems);
			      this.$message.error(`${invalidItems.length} 条卫材明细缺少库存ID，请重新加载数据`);
			      return;
			    }
			
			    // 准备接口数据
			    const submitData = this.prepareAddOutboundData();
			    
			    // 设置状态和ID
			    submitData.state = 2; // 已提交状态
			    
			    // 如果是编辑模式，确保传递id
			    if (this.mode === 'edit' && this.currentRow && this.currentRow.id) {
			      submitData.id = this.currentRow.id;
			    }
			
			    console.log('提交编辑数据:', {
			      模式: this.mode,
			      单据ID: submitData.id,
			      数据详情: submitData
			    });
			
			    // 调用编辑接口
			    const result = await editWCdocOut(submitData);
			
			    if (result.code === 200) {
			      this.$message.success(result.message || '修改成功');
			      
			      // 直接关闭模态框，不显示关闭提示
			      this.$emit('refresh'); // 触发父组件刷新
			      this.$emit('close');   // 关闭模态框
			    } else {
			      this.$message.error(result.message || '修改失败');
			      
			      // 如果是invId相关错误，提供更详细的提示
			      if (result.message && result.message.includes('invId')) {
			        this.$message.warning('库存ID错误，请检查卫材明细数据');
			      }
			    }
			  } catch (error) {
			    console.error('修改失败:', error);
			    
			    // 更详细的错误处理
			    if (error.response) {
			      console.error('接口返回错误:', error.response.data);
			      this.$message.error(`接口错误: ${error.response.data.message || '未知错误'}`);
			    } else if (error.request) {
			      console.error('请求未收到响应:', error.request);
			      this.$message.error('网络错误: 请求未收到响应');
			    } else {
			      console.error('请求配置错误:', error.message);
			      this.$message.error(`请求错误: ${error.message}`);
			    }
			  }
			},
			
			// 完成：处理docOutWCJoin接口返回数据
			async processDocOutJoinResponse(returnRow, joinResult) {
			  if (joinResult.success) {
			    // 接口调用成功，更新可出库数量等信息
			    const availableQuantity = this.getSafeNumber(joinResult.data.availableQuantity, returnRow.purcCnt);
			    const purcCnt = this.getSafeNumber(joinResult.data.purcCnt, returnRow.purcCnt);
			    
			    // 关键修改：更新可出库数量，但保持用户设置的apllyAmt不变（除非超过可出库数量）
			    returnRow.availableQuantity = availableQuantity;
			    returnRow.apllyAmt = purcCnt;
			    
			    // 如果当前出库数量大于可出库数量，则调整为可出库数量
			    if (returnRow.apllyAmt > availableQuantity) {
			      returnRow.apllyAmt = availableQuantity;
			      console.log(`调整出库数量为可出库数量: ${availableQuantity}`);
			    }
			    
			    returnRow.joinData = joinResult.data;
			    returnRow.hasJoinWarning = false;
			    returnRow.isError = false;
			    
			    console.log(`卫材 ${returnRow.eisaiName} 库存验证成功`, {
			      可出库数量: availableQuantity,
			      当前库存: purcCnt,
			      当前出库数量: returnRow.apllyAmt
			    });
			  } else {
			    // 接口调用失败，使用原始数据，标记警告
			    returnRow.availableQuantity = returnRow.purcCnt;
			    returnRow.apllyAmt = Math.min(returnRow.apllyAmt, returnRow.purcCnt); // 确保不超过库存
			    returnRow.hasJoinWarning = true;
			    returnRow.joinError = joinResult.error;
			    returnRow.isError = false;
			    
			    console.warn(`卫材 ${returnRow.eisaiName} 库存验证失败:`, joinResult.error);
			  }
			  
			  // 重新计算金额
			  returnRow.retnAmt = this.calculateAmount(returnRow.retnPric, returnRow.apllyAmt);
			  returnRow.saleAmt = this.calculateAmount(returnRow.salePric, returnRow.apllyAmt);
			  
			  return returnRow;
			},
			
			// 新增：处理卫材明细并调用docOutWCJoin接口
			async processDrugItemWithDocOutJoin(drugItem, sourcePurchase, index) {
			  try {
			    console.log(`开始处理卫材 ${index + 1}:`, drugItem.eisaiName);
			
			    // 创建基本的退库行数据
			    const returnRow = this.createReturnRowFromDrugItem(drugItem, sourcePurchase, index);
			    
			    // 验证数据完整性
			    if (!this.validateDrugItemForReturn(returnRow)) {
			      console.warn('卫材数据不完整，跳过:', drugItem);
			      const errorRow = this.createErrorRowFromDrugItem(drugItem, sourcePurchase, index, 
			        new Error('卫材数据不完整，缺少必要字段'));
			      this.tableData.push(errorRow);
			      return;
			    }
			
			    // 关键修改：调用docOutWCJoin接口验证可出库数量
			    console.log(`调用docOutWCJoin接口验证卫材 ${drugItem.eisaiName} 的库存`);
			    const joinResult = await this.callDocOutJoinForValidation(returnRow);
			    
			    // 处理接口返回结果
			    await this.processDocOutJoinResponse(returnRow, joinResult);
			
			    // 添加到表格数据
			    this.tableData.push(returnRow);
			    
			    console.log(`卫材 ${drugItem.eisaiName} 处理完成，已添加到表格`);
			
			  } catch (error) {
			    console.error(`处理卫材明细失败 [${index}]:`, drugItem, error);
			    // 即使处理失败，也创建错误行数据以便用户查看
			    const errorRow = this.createErrorRowFromDrugItem(drugItem, sourcePurchase, index, error);
			    this.tableData.push(errorRow);
			  }
			},
			
			// 修改：安全数值转换方法
			getSafeNumber(value, defaultValue = 0) {
			  console.log('安全数值转换:', { 输入值: value, 默认值: defaultValue });
			  
			  if (value === null || value === undefined || value === '') {
			    console.log('输入值为空，返回默认值:', defaultValue);
			    return defaultValue;
			  }
			  
			  // 如果是数字类型
			  if (typeof value === 'number') {
			    if (isNaN(value)) {
			      console.log('输入值为NaN，返回默认值:', defaultValue);
			      return defaultValue;
			    }
			    console.log('输入值为数字，直接返回:', value);
			    return value;
			  }
			  
			  // 如果是字符串
			  if (typeof value === 'string') {
			    const trimmed = value.trim();
			    if (trimmed === '') {
			      console.log('输入值为空字符串，返回默认值:', defaultValue);
			      return defaultValue;
			    }
			    
			    const num = Number(trimmed);
			    if (isNaN(num)) {
			      console.log('字符串转换为NaN，返回默认值:', defaultValue);
			      return defaultValue;
			    }
			    
			    console.log('字符串转换成功:', num);
			    return num;
			  }
			  
			  // 其他类型
			  try {
			    const num = Number(value);
			    if (isNaN(num)) {
			      console.log('其他类型转换为NaN，返回默认值:', defaultValue);
			      return defaultValue;
			    }
			    console.log('其他类型转换成功:', num);
			    return num;
			  } catch (e) {
			    console.log('转换异常，返回默认值:', defaultValue);
			    return defaultValue;
			  }
			},

			// 新增：从采购入库单填充基本信息
			fillBasicInfoFromPurchase(purchaseDetail) {
			  try {
			    // 保留现有表单数据，只更新关键字段
			    this.addForm = {
			      ...this.addForm,
			      // 关键字段更新
			      id: purchaseDetail.id || '', // 如果是编辑模式
			      docNum: purchaseDetail.docNum || `TH${new Date().getTime()}`, // 退库单号
			      busDate: purchaseDetail.busDate || purchaseDetail.invoDate || new Date().toISOString().split('T')[0],
			      supplierId: purchaseDetail.supplyCandidateId || purchaseDetail.supplierId,
			      supplierName: purchaseDetail.supplierName || '',
			      sourceDocNum: purchaseDetail.docNum, // 来源单号
			      sourceDocId: purchaseDetail.id, // 来源单ID
			      purcInvoCodg: purchaseDetail.purcInvoCodg || '', // 采购发票号
			      remark: purchaseDetail.remarks || `来源于入库单: ${purchaseDetail.docNum}`,
			      // 金额信息
			      costAmt: '0.00', // 初始为0，后面重新计算
			      saleAmt: '0.00'  // 初始为0，后面重新计算
			    };
			
			    console.log('填充的基本信息:', this.addForm);
			  } catch (error) {
			    console.error('填充基本信息失败:', error);
			  }
			},

			// 修改：从采购入库单处理卫材明细列表
			async processDrugListForReturn(drugList, sourcePurchase) {
			  try {
			    let processedCount = 0;
			    let skippedCount = 0;
			    let joinSuccessCount = 0;
			    let joinErrorCount = 0;
			
			    console.log('开始处理卫材明细列表，数量:', drugList.length);
			
			    // 清空现有表格数据，避免重复
			    this.tableData = [];
			
			    // 使用for循环顺序处理，避免并发问题
			    for (let index = 0; index < drugList.length; index++) {
			      const drugItem = drugList[index];
			
			      try {
			        console.log(`处理卫材 ${index + 1}/${drugList.length}:`, drugItem.eisaiName);
			
			        // 为每个卫材明细创建退库行
			        const returnRow = this.createReturnRowFromDrugItem(drugItem, sourcePurchase, index);
			
			        // 验证数据完整性
			        if (this.validateDrugItemForReturn(returnRow)) {
			          // 关键修改：调用docOutWCJoin接口验证可出库数量
			          const joinResult = await this.callDocOutJoinForValidation(returnRow);
			
			          // 处理接口返回结果
			          await this.processDocOutJoinResponse(returnRow, joinResult);
			
			          if (joinResult.success) {
			            joinSuccessCount++;
			          } else {
			            joinErrorCount++;
			          }
			
			          // 添加到表格数据
			          this.tableData.push(returnRow);
			          processedCount++;
			
			          // 实时更新界面显示进度
			          this.loadingText = `正在处理卫材 ${index + 1}/${drugList.length}...`;
			
			        } else {
			          console.warn(`卫材数据不完整，跳过:`, drugItem);
			          skippedCount++;
			        }
			      } catch (itemError) {
			        console.error(`处理卫材明细失败 [${index}]:`, drugItem, itemError);
			        skippedCount++;
			
			        // 即使处理失败，也创建基本行数据并标记错误
			        const errorRow = this.createErrorRowFromDrugItem(drugItem, sourcePurchase, index, itemError);
			        this.tableData.push(errorRow);
			        processedCount++;
			      }
			
			      // 添加短暂延迟，避免接口调用过于频繁
			      if (index < drugList.length - 1) {
			        await new Promise(resolve => setTimeout(resolve, 100));
			      }
			    }
			
			    console.log(`卫材明细处理完成: 成功 ${processedCount} 条, 跳过 ${skippedCount} 条`);
			    console.log(`docOutWCJoin接口调用: 成功 ${joinSuccessCount} 条, 失败 ${joinErrorCount} 条`);
			
			    // 重新计算合计金额
			    this.calculateTotals();
			
			    // 显示处理结果
			    if (processedCount === 0) {
			      this.$message.warning('没有成功处理任何卫材明细');
			    } else if (joinErrorCount > 0) {
			      this.$message.warning(`处理完成：成功 ${joinSuccessCount} 条，失败 ${joinErrorCount} 条`);
			    } else {
			      this.$message.success(`成功处理 ${processedCount} 条卫材明细`);
			    }
			
			  } catch (error) {
			    console.error('处理卫材明细列表失败:', error);
			    this.$message.error('处理卫材明细失败');
			    throw error;
			  }
			},

			// 新增：创建错误处理行
			createErrorRowFromDrugItem(drugItem, sourcePurchase, index, error) {
				return {
					id: drugItem.id,
					eisaiId: drugItem.eisaiId,
					eisaiName: drugItem.eisaiName || '未知卫材',
					drugCode: drugItem.drugCode,
					drugSpecifications: drugItem.drugSpecifications,
					purcCnt: this.getNumberValue(drugItem.purcCnt),
					retnCnt: 0,
					purcType: drugItem.purcType || '2',
					retnPric: this.getNumberValue(drugItem.purcPric),
					salePric: this.getNumberValue(drugItem.salePric),
					retnAmt: 0,
					saleAmt: 0,
					availableQuantity: 0,
					hasJoinWarning: true,
					joinError: error.message || '处理失败',
					isError: true,
					errorMessage: `处理失败: ${error.message}`,
					sourceDocNum: sourcePurchase.docNum,
					sourceDocId: sourcePurchase.id,
					editing: false
				};
			},

			async callDocOutJoinForValidation(drugRow) {
			  try {
			    // 关键修改：使用getDrugDetails返回的参数
			    const params = {
			      amount: this.getNumberValue(drugRow.purcCnt, 1), // 申请出口数量 = getDrugDetails返回的purcCnt
			      invId: drugRow.invId || drugRow.invyId, // 库存id = getDrugDetails返回的invyId
			      purcType: drugRow.purcType || '2' // 库存类型
			    };
			
			    console.log('调用docOutWCJoin接口参数:', {
			      卫材名称: drugRow.eisaiName,
			      参数: params,
			      来源数据: {
			        purcCnt: drugRow.purcCnt,
			        invId: drugRow.invId,
			        invyId: drugRow.invyId,
			        purcType: drugRow.purcType
			      }
			    });
			
			    // 参数验证
			    if (!params.invId) {
			      console.error('缺少库存ID参数，无法调用接口');
			      return {
			        success: false,
			        error: '缺少库存ID参数'
			      };
			    }
			
			    if (!params.amount || params.amount <= 0) {
			      console.error('库存数量无效，无法调用接口');
			      return {
			        success: false,
			        error: '库存数量无效'
			      };
			    }
			
			    // 调用docOutWCJoin接口
			    const response = await docOutWCJoin(params);
			
			    if (response.code === 200) {
			      console.log('docOutWCJoin接口调用成功:', response.data);
			      
			      // 关键修改：正确处理接口返回数据
			      let resultData = {};
			      
			      if (response.data && typeof response.data === 'object') {
			        // 确保返回的数据包含必要的字段
			        resultData = {
			          // 优先使用接口返回的purcCnt，这是关键修改点
			          purcCnt: this.getNumberValue(response.data.purcCnt, drugRow.purcCnt),
			          availableQuantity: this.getNumberValue(response.data.availableQuantity) || 
			                           this.getNumberValue(response.data.purcCnt) || 
			                           drugRow.purcCnt,
			          // 保留其他返回字段
			          ...response.data
			        };
			      } else {
			        // 如果返回数据格式不正确，使用默认值
			        resultData = {
			          purcCnt: drugRow.purcCnt,
			          availableQuantity: drugRow.purcCnt
			        };
			      }
			      
			      return {
			        success: true,
			        data: resultData
			      };
			    } else {
			      console.error('docOutWCJoin接口调用失败:', response.message);
			      return {
			        success: false,
			        error: response.message || '接口调用失败'
			      };
			    }
			  } catch (error) {
			    console.error('调用docOutWCJoin接口异常:', error);
			    return {
			      success: false,
			      error: error.message || '接口调用异常'
			    };
			  }
			},

			createReturnRowFromDrugItem(drugItem, sourcePurchase, index) {
			  const returnRow = {
			    // 唯一标识
			    id: drugItem.id || `return_${sourcePurchase.id}_${index}_${Date.now()}`,
			    
			    // 卫材基本信息
			    eisaiId: drugItem.eisaiId,
			    eisaiName: drugItem.eisaiName || '未知卫材',
			    drugCode: drugItem.drugCode || '',
			    specDesc: drugItem.specDesc || drugItem.drugSpecifications || '',
			    
			    // 关键修改：库存相关字段
			    invId: drugItem.invyId || drugItem.invId || drugItem.id,
			    invyId: drugItem.invyId || drugItem.invId || drugItem.id,
			    
			    // 库存数量 - 来自getDrugDetails接口的purcCnt
			    purcCnt: this.getSafeNumber(drugItem.purcCnt, 0),
			    
			    // 关键修改：出库数量初始化为可出库数量或1，使用apllyAmt字段
			    apllyAmt: 1, // 默认出库数量为1
			    
			    // 库存类型
			    purcType: (drugItem.purcType || '2').toString(),
			    
			    // 价格信息
			    retnPric: this.getSafeNumber(drugItem.purcPric || drugItem.retnPric, 0),
			    salePric: this.getSafeNumber(drugItem.salePric, 0),
			    
			    // 金额信息（初始为0，后面计算）
			    retnAmt: 0,
			    saleAmt: 0,
			    
			    // 生产信息
			    manuLotnum: drugItem.manuLotnum || '',
			    expyDate: drugItem.expyDate || '',
			    
			    // 厂家信息
			    prodentpName: drugItem.prodentpName || '',
			    prodentpNameId: this.getSafeNumber(drugItem.prodentpNameId),
			    
			    // 单位信息
			    unt: drugItem.unt || (drugItem.purcType === '1' ? drugItem.dosUnt : drugItem.pacUnt) || '个',
			    dosUnt: drugItem.dosUnt || '最小单位',
			    pacUnt: drugItem.pacUnt || '包装单位',
			    
			    // 来源信息
			    sourceDocNum: sourcePurchase.docNum,
			    sourceDocId: sourcePurchase.id,
			    
			    // 状态信息
			    editing: false,
			    hasJoinWarning: false,
			    isError: false,
			    availableQuantity: 0 // 可出库数量，等待接口返回
			  };
			
			  // 初始计算金额
			  returnRow.retnAmt = this.calculateAmount(returnRow.retnPric, returnRow.apllyAmt);
			  returnRow.saleAmt = this.calculateAmount(returnRow.salePric, returnRow.apllyAmt);
			
			  console.log('创建的退库行数据:', returnRow);
			  return returnRow;
			},

			// 新增：安全获取数值
			getNumberValue(value, defaultValue = 0) {
				if (value === null || value === undefined || value === '') return defaultValue;
				const num = Number(value);
				return isNaN(num) ? defaultValue : num;
			},

			// 新增：计算金额
			calculateAmount(price, quantity) {
			  const priceNum = this.getSafeNumber(price, 0);
			  const quantityNum = this.getSafeNumber(quantity, 0);
			  
			  const result = priceNum * quantityNum;
			  
			  // 四舍五入保留2位小数
			  return Math.round(result * 100) / 100;
			},

			// 新增：验证卫材明细数据完整性
			validateDrugItemForReturn(drugItem) {
				// 必需字段检查
				const requiredFields = ['eisaiId', 'eisaiName'];
				const missingFields = requiredFields.filter(field => !drugItem[field]);

				if (missingFields.length > 0) {
					console.warn('卫材数据缺失必需字段:', missingFields, drugItem);
					return false;
				}

				// 数量验证
				if (this.getNumberValue(drugItem.purcCnt) <= 0) {
					console.warn('卫材库存数量无效:', drugItem.purcCnt);
					return false;
				}

				return true;
			},

			// 打印
			handlePrint() {
				this.$confirm('请选择打印方式', '打印设置', {
					confirmButtonText: 'Lodop打印',
					cancelButtonText: '浏览器打印',
					type: 'warning'
				}).then(() => {
					this.printWithLodop();
				}).catch(() => {
					this.printWithBrowser();
				});
			},

			// Lodop打印
			printWithLodop() {
				// 实际项目中这里应该调用打印接口
				this.$message.info('Lodop打印功能');
			},

			// 浏览器打印
			printWithBrowser() {
				window.print();
			},
			// 重置所有表单和状态
			resetAllForms() {
				// 重置主表单
				this.addForm = addForm.map(v => ({
					...v
				}))[0];

				// 重置明细表单
				this.addMainForm = {
					...this.addForm.list[0]
				};

				// 重置表格数据
				this.tableData = [];

				// 重置金额合计
				this.cbValue = '';
				this.lsValue = '';

				// 重置其他状态
				this.isEditing = false;
				this.purcType = '1';
				this.unt = '';
				this.minUnt = '';
				this.packNum = 0;
				this.getMinMax = 0;

				// 重置表单验证
				if (this.$refs.addForm) {
					this.$refs.addForm.resetFields();
				}
				if (this.$refs.addMainForm) {
					this.$refs.addMainForm.resetFields();
				}

				// 重置当前日期时间
				this.getNowDateTime();
			},

			// 处理单据类型变化
			handleDocTypeChange() {
				this.$message.info('切换到出库单模式');
			}
		}
	}
</script>

<style lang="less" scoped>
	// 卫材选择器样式优化
	.drug-name-select {
	  width: 100%;
	  
  /deep/ .el-select {
    .el-input__inner {
      min-width: 300px; // 输入框最小宽度
    }
  }
  /deep/ .el-select-dropdown {
    min-width: 500px !important; // 关键：下拉框最小宽度500px
    max-width: 800px;
    max-height: 400px;
    overflow-y: auto;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .el-select-dropdown__list {
      padding: 0;
      min-width: 500px;
      
      .el-select-dropdown__item {
        padding: 0;
        height: auto;
        min-width: 500px;
        
        &.is-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        &:hover:not(.is-disabled) {
          .option-item-content {
            background-color: #f5f7fa;
          }
        }
        
        &.selected {
          .option-item-content {
            background-color: #ecf5ff;
            border-left: 3px solid #409eff;
            
            .field-cell {
              &.name-cell {
                color: #409eff;
                font-weight: 600;
              }
              &.index-cell,
              &.spec-cell,
              &.stock-cell,
              &.batch-cell,
              &.manufacturer-cell {
                color: #409eff;
              }
            }
          }
        }
        
        .option-item-content {
          transition: background-color 0.2s;
          border-bottom: 1px solid #f0f0f0;
          min-width: 500px;
          
          &:hover {
            background-color: #f5f7fa;
          }
          
          .field-cell {
            padding: 8px 4px;
            font-size: 12px;
            
            // 库存序号
            &.index-cell {
              font-family: 'Courier New', monospace;
              background-color: #f9f9f9;
              border-radius: 3px;
              padding: 4px 8px;
              text-align: center;
              min-width: 60px;
              max-width: 60px;
            }
            
            // 卫材名称 - 固定188px宽度
            &.name-cell {
              color: #333;
              font-weight: 500;
              min-width: 188px;
              max-width: 188px;
              width: 188px;
              
              // 强制超出显示...
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            
            // 卫材规格
            &.spec-cell {
              color: #666;
              min-width: 150px;
              max-width: 150px;
              width: 150px;
            }
            
            // 库存数量
            &.stock-cell {
              font-family: 'Courier New', monospace;
              background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
              border-radius: 3px;
              padding: 4px 8px;
              text-align: right;
              min-width: 100px;
              max-width: 100px;
              width: 100px;
              font-weight: 600;
              color: #e6a23c;
            }
            
            // 批次号
            &.batch-cell {
              background: #f5f5f5;
              border-radius: 3px;
              padding: 4px 8px;
              text-align: center;
              font-family: 'Courier New', monospace;
              min-width: 120px;
              max-width: 120px;
              width: 120px;
            }
            
            // 生产厂家
            &.manufacturer-cell {
              background: linear-gradient(135deg, #e8f5e9 0%, #d9f2db 100%);
              border-radius: 3px;
              padding: 4px 8px;
              border-left: 2px solid #67c23a;
              min-width: 150px;
              max-width: 150px;
              width: 150px;
            }
          }
        }
      }
    }
    
    // 下拉框滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
      
      &:hover {
        background: #a8a8a8;
      }
    }
  }
  
  // 下拉框搜索区域的样式
  /deep/ .el-select-dropdown__search {
    border-bottom: 1px solid #e0e0e0;
    background-color: #f8f9fa;
    
    .el-input {
      .el-input__inner {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        
        &:focus {
          border-color: #409eff;
        }
      }
    }
  }
}

// 确保el-popper的最小宽度
/deep/ .el-popper {
  &.el-select-dropdown {
    min-width: 500px !important;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .drug-name-select {
    /deep/ .el-select {
      .el-input__inner {
        min-width: 200px;
      }
    }
    
    /deep/ .el-select-dropdown {
      min-width: 100vw !important;
      max-width: 100vw;
      margin-left: -20px;
      
      .el-select-dropdown__list {
        min-width: 100vw;
        
        .el-select-dropdown__item {
          min-width: 100vw;
          
          .option-item-content {
            grid-template-columns: 50px 150px 120px 80px 100px 120px;
            gap: 4px;
            padding: 6px 8px;
            min-width: 100vw;
            
            .field-cell {
              font-size: 11px;
              padding: 4px 2px;
              
              // 在移动端调整宽度
              &.name-cell {
                min-width: 150px;
                max-width: 150px;
                width: 150px;
              }
              &.spec-cell {
                min-width: 120px;
                max-width: 120px;
                width: 120px;
              }
              &.stock-cell {
                min-width: 80px;
                max-width: 80px;
                width: 80px;
              }
              &.batch-cell {
                min-width: 100px;
                max-width: 100px;
                width: 100px;
              }
              &.manufacturer-cell {
                min-width: 120px;
                max-width: 120px;
                width: 120px;
              }
            }
          }
        }
      }
    }
  }
}

// 暗色模式适配
@media (prefers-color-scheme: dark) {
  .drug-name-select {
    /deep/ .el-select-dropdown {
      background-color: #2a2a2a;
      border-color: #444;
      
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          &:hover:not(.is-disabled) {
            .option-item-content {
              background-color: #3a3a3a;
            }
          }
          
          &.selected {
            .option-item-content {
              background-color: #1a3250;
              border-left-color: #409eff;
              
              .field-cell {
                color: #409eff;
              }
            }
          }
          
          .option-item-content {
            border-bottom-color: #444;
            
            .field-cell {
              &.index-cell {
                background-color: #3a3a3a;
                color: #ccc;
              }
              
              &.name-cell {
                color: #fff;
              }
              
              &.spec-cell {
                color: #ccc;
              }
              
              &.stock-cell {
                background: linear-gradient(135deg, #4a3c27 0%, #5a4c37 100%);
                color: #e6a23c;
              }
              
              &.batch-cell {
                background: #3a3a3a;
                color: #ccc;
              }
              
              &.manufacturer-cell {
                background: linear-gradient(135deg, #2a3a2a 0%, #3a4a3a 100%);
                border-left-color: #67c23a;
                color: #85ce61;
              }
            }
          }
        }
      }
    }
  }
}
	.add-ret-container {
		height: calc(90vh - 40px);
		display: flex;
		flex-direction: column;
		background-color: #f5f7fa;
		padding: 8px;
		border-radius: 8px;
		overflow: hidden;
		
		/* 操作按钮样式优化 */
		.operation-buttons {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			gap: 4px;
		}

		.operation-buttons .el-button {
			margin: 0;
			padding: 4px 8px;
			height: 24px;
			line-height: 1;
		}

		/* 加载状态样式 */
		.global-loading {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 0.8);
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 9999;
		}

		.interface-loading {
			text-align: center;
			padding: 20px;
		}

		.page-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: #fff;
			padding: 15px;
			border-radius: 4px;
			margin-bottom: 15px;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

			.doc-type-tabs {
				.el-radio-group {
					.el-radio-button {
						.el-radio-button__inner {
							padding: 10px 20px;
							font-size: 16px;
							font-weight: bold;
						}
					}
				}
			}

			.doc-info {
				display: flex;
				align-items: center;

				.doc-date,
				.doc-number {
					display: flex;
					align-items: center;
					margin-left: 20px;

					span {
						margin-right: 10px;
						font-size: 14px;
					}
				}
			}

			.header-actions {
				.el-button {
					margin-left: 5px;
				}
			}
		}

		.main-content-wrapper {
			flex: 1;
			background: #fff;
			border-radius: 4px;
			overflow: hidden;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			margin-bottom: 15px;

			.purchase-detail-content {
				height: 100%;

				// 继承第一个文件的样式
				.addAcc {
					.tabs {
						.tabsMain {
							display: flex;
							flex-direction: column;
							gap: 20px;

							// 各部分标题样式
							.section-title {
								font-size: 14px;
								font-weight: 600;
								color: #303133;
								padding-left: 8px;
								border-left: 4px solid #409EFF;
							}

							// 头部表单区域
							.header-section {
								background: #f8f9fa;
								border-radius: 6px;
								border: 1px solid #e6e8eb;

								.headerForm {
									/deep/ .el-form-item {
										margin-bottom: 12px;

										.el-form-item__label {
											font-weight: 500;
											color: #606266;
											font-size: 13px;
										}

										.el-input__inner {
											border-radius: 4px;
											border: 1px solid #dcdfe6;

											&:hover {
												border-color: #c0c4cc;
											}

											&:focus {
												border-color: #409EFF;
											}
										}
									}
								}
							}

							// 主体表单区域
							.main-section {
								background: #f8f9fa;
								border-radius: 6px;
								border: 1px solid #e6e8eb;

								.mainForm {
									/deep/ .el-form-item {

										.el-form-item__label {
											font-weight: 500;
											color: #606266;
											font-size: 13px;
										}

										.input-with-select {
											/deep/ .el-select .el-input {
												width: 99px;
											}

											/deep/ .el-input-group__prepend {
												background-color: #f5f7fa;
											}
										}
									}

									/deep/ .el-select-dropdown__item {
										border: 1px solid #eeeeee;
										padding: 0;
										height: 40px;
										#optionItem {
											width: 100%;
											height: 100%;
											display: flex;
											align-items: center;
											text-align: center;
											justify-content: space-around;

											span {
												display: inline-block;
												font-size: 12px;
												height: 40px;
												white-space: nowrap;
												overflow: hidden;
												text-overflow: ellipsis;
											}
										}
									}
								}
							}

							// 表格区域
							.table-section {
								.section-header {
									display: flex;
									justify-content: space-between;
									align-items: center;
									margin-bottom: 16px;

									.section-title {
										font-size: 16px;
										font-weight: 600;
										color: #303133;
										margin: 0;
										padding-left: 8px;
										border-left: 4px solid #67C23A;
									}

									.total-info {
										display: flex;
										gap: 20px;

										.total-item {
											font-size: 14px;
											color: #606266;
											font-weight: 500;

											&:first-child {
												color: #ff6b35;
											}

											&:nth-child(2) {
												color: #67c23a;
											}
										}
									}
								}

								.table {
									/deep/ .el-table {
										border-radius: 6px;
										overflow: hidden;
										border: 1px solid #e6e8eb;

										.el-table__header-wrapper {
											th {
												background-color: #f5f7fa;
												font-weight: 600;
												color: #606266;
												font-size: 13px;
											}
										}

										.el-table__body-wrapper {
											tr:hover>td {
												background-color: #f0f7ff;
											}

											.cell {
												font-size: 12px;
												font-weight: 400;
												color: #0c0c0c;
												text-align: center;
											}
										}

										.el-table__cell {
											padding: 8px 0;
										}
									}
								}
							}
						}
					}
				}
			}
		}

		.action-buttons {
			display: flex;
			justify-content: flex-end;
			padding: 10px 0;

			.el-button {
				margin-left: 10px;
			}
		}
	}

	// 响应式设计
	@media (max-width: 1200px) {
		.add-ret-container {
			.page-header {
				flex-direction: column;
				align-items: flex-start;

				.doc-info {
					margin-top: 10px;
					margin-left: 0;
				}

				.header-actions {
					margin-top: 10px;
				}
			}
		}
	}

	// 打印样式
	@media print {

		.page-header,
		.action-buttons {
			display: none !important;
		}

		.add-ret-container {
			padding: 0;
			background: white;
		}
	}

	// 编辑操作按钮样式优化
	.edit-actions {
		display: flex;
		gap: 4px;
		justify-content: center;

		.el-button {
			min-width: 50px;
			padding: 6px 8px;
			font-size: 12px;

			&.is-disabled {
				opacity: 0.5;
				cursor: not-allowed;
			}
		}
	}

	// 表格单元格样式优化
	/deep/ .el-table {
		.cell {
			line-height: 1.4;

			.el-input {
				.el-input__inner {
					height: 28px;
					line-height: 28px;
					text-align: center;
				}
			}
		}

		// 库存类型颜色样式
		.purc-type-min {
			color: #67C23A;
			font-weight: 500;
		}

		.purc-type-pac {
			color: #409EFF;
			font-weight: 500;
		}
	}
	
	// 选择器下拉框样式优化
	/deep/ .el-select-dropdown {
		border: none;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		border-radius: 4px;

		.el-select-dropdown__item {
			font-size: 13px;
			line-height: 26px;
			height: 26px;
			&.selected {
				color: #409EFF;
				font-weight: 500;
			}

			&:hover {
				background-color: #f5f7fa;
			}
		}

		.select-header {
			background-color: #f5f7fa;
			border-bottom: 1px solid #e6e8eb;
			font-weight: 600;
			color: #303133;
		}
	}
</style>